import axios from "axios";
import { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import styled from "styled-components";
import DOMPurify from "dompurify";
import { Helmet } from "react-helmet-async";

// type
import { DetailProps } from "../model/data";
import NoticeDetailNav from "./NoticeDetailNav";

const Container = styled.div`
    .detail_common {
        border-top: 2px solid var(--subColor01);
    }
    .detail_common .detail_page_youtube_wrap {
        position: relative;
        width: 100%;
        height: 0;
        padding-bottom: 56.25%;
    }
    .detail_common .detail_page_youtube {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }
    .info_wrap.type_01 {
        padding: 32px 0px;
        border-top: 2px solid var(--subColor01);
        border-bottom: 1px solid #dedede;
    }
    .info_wrap.type_01 .category {
        width: fit-content;
        border: 1px solid var(--pointColor01);
        border-radius: 9999px;
        margin-left: auto;
        margin-right: auto;
        color: var(--pointColor01);
    }
    .info_wrap.type_01 .sub_info_wrap {
        display: flex;
        gap: 24px;
        width: fit-content;
        margin-left: auto;
        margin-right: auto;
    }
    .info_wrap.type_01 .date_wrap,
    .info_wrap.type_01 .views_wrap {
        display: flex;
        gap: 8px;
    }
    .contents_wrap.type_01 {
        display: flex;
        flex-direction: column;
        gap: 24px;
        padding-bottom: 80px;
    }
    .contents_wrap.type_01 > img {
        display: block;
        width: max-content;
        max-width: calc(100% - 32px);
        margin: 0px auto;
    }
    .contents_wrap.type_01 > .main_table {
        width: 100%;
        max-width: 950px;
        margin-left: auto;
        margin-right: auto;
    }
    .contents_wrap.type_01 > .main_table td {
        text-align: center;
        border: 1px solid var(--subColor05);
        padding: 10px;
    }
    .contents_wrap.type_01 img:not(.txc-emo) {
        margin-left: auto;
        margin-right: auto;
    }
    .ql-editor {
        .editor-item {
            * {
                max-width: 100%;
                font-family: inherit;
            }
            a {
                display: inline;
            }
            li {
                list-style: unset;
            }
            table {
                width: 100%;
                max-width: 950px;
                margin-left: auto;
                margin-right: auto;
            }
        }
    }
    .contents_wrap.type_01 .btn_download {
        cursor: pointer;
    }
    .btn_download .txt {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        height: 24px;
        line-height: 24px;
    }
    .btn_download {
        display: flex;
        align-items: center;
        gap: 8px;
        width: 100%;
        height: 52px;
        border-radius: 4px;
        padding: 0px 24px;
        background-color: var(--subColor07);
    }
    .btn_download:first-of-type {
        margin-top: 80px;
    }
    .btn_download .icon {
        color: var(--subColor04);
    }
    .btn_download .icon_download {
        margin-left: auto;
    }
    @media screen and (max-width: 1279px) {
        .ql-editor {
            overflow-x: scroll;
            .editor-item {
                width: fit-content;
            }
        }
    }

    /* editor */
    .ql-editor {
        /* content-view */
        .tx-content-container em {
            font-style: italic;
        }
        .tx-content-container ol {
            padding-left: 35px;
            margin-left: 0;
        }
        .tx-content-container ol li {
            list-style-type: inherit;
        }
        .tx-content-container ul {
            list-style-type: disc;
            padding-left: 30px;
            margin-left: 0;
        }
        .tx-content-container ul li {
            list-style-type: inherit;
        }
        .tx-content-container hr,
        .tx-content-container h1,
        .tx-content-container h2,
        .tx-content-container h3,
        .tx-content-container h4,
        .tx-content-container h5,
        .tx-content-container h6 {
            display: block;
        }
        .tx-content-container button {
            background-color: transparent;
            border: none;
            padding: 0;
            text-align: left;
            margin: 0;
        }
        .tx-content-container button img {
            vertical-align: middle;
        }
        .tx-hr-border-1 {
            height: 1px;
            border: 0 none;
            border-top: 1px solid #666;
            display: block;
        }
        .tx-hr-border-2 {
            height: 7px;
            border-top: 1px solid #666;
            border-bottom: 3px solid #666;
            border-left: 0 none;
            border-right: 0 none;
            display: block;
        }
        .tx-hr-border-3 {
            height: 1px;
            border: 0 none;
            border-top: 1px dotted #666;
            display: block;
        }
        div.tx-hr-image-1 {
            border: 0 none;
            height: 15px;
            background: url(/editor/images/deco/contents/horizontalrule/line03.gif?v=2) repeat-x scroll left;
            width: 99%;
        }
        div.tx-hr-image-1 hr {
            position: relative;
            top: -999px;
            left: -999px;
            border: 0 none;
        }
        div.tx-hr-image-2 {
            border: 0 none;
            height: 15px;
            background: url(/editor/images/deco/contents/horizontalrule/line05.gif?v=2) repeat-x scroll left;
            width: 99%;
        }
        div.tx-hr-image-2 hr {
            position: relative;
            top: -999px;
            left: -999px;
            border: 0 none;
        }
        div.tx-hr-image-3 {
            border: 0 none;
            height: 15px;
            background: url(/editor/images/deco/contents/horizontalrule/line06.gif?v=2) repeat-x scroll left;
            width: 99%;
        }
        div.tx-hr-image-3 hr {
            position: relative;
            top: -999px;
            left: -999px;
            border: 0 none;
        }
        div.tx-hr-image-4 {
            border: 0 none;
            height: 15px;
            background: url(/editor/images/deco/contents/horizontalrule/line08.gif?v=2) no-repeat scroll center;
            width: 99%;
        }
        div.tx-hr-image-4 hr {
            position: relative;
            top: -999px;
            left: -999px;
            border: 0 none;
        }
        blockquote.tx-quote1 {
            border: 1px solid #dbdbdb;
            margin: 10px;
            padding: 10px;
        }
        blockquote.tx-quote2 {
            border: 3px solid #dbdbdb;
            margin: 10px;
            padding: 10px;
        }
        blockquote.tx-quote3 {
            border: 1px dashed #dbdbdb;
            margin: 10px;
            padding: 10px;
        }
        blockquote.tx-quote4 {
            border: none;
            background: url(/editor/images/deco/contents/quote/titation01.gif?v=2) top left no-repeat;
            padding: 0 20px 10px 20px;
            margin: 10px;
        }
        blockquote.tx-quote5 {
            border: none;
            border-left: 2px solid #dbdbdb;
            margin: 10px;
            padding: 10px;
        }
        .txc-textbox1 {
            padding: 10px;
            background-color: #fff;
            border: 1px solid #f7f7f7;
        }
        .txc-textbox2 {
            padding: 10px;
            background-color: #eee;
            border: 1px solid #eee;
        }
        .txc-textbox3 {
            padding: 10px;
            background-color: #f2f2b8;
            border: 1px solid #f2f2b8;
        }
        .txc-textbox4 {
            padding: 10px;
            background-color: #fedec7;
            border: 1px solid #fedec7;
        }
        .txc-textbox5 {
            padding: 10px;
            background-color: #e7fdb5;
            border: 1px solid #e7fdb5;
        }
        .txc-textbox6 {
            padding: 10px;
            background-color: #dbe8fb;
            border: 1px solid #dbe8fb;
        }
        .txc-textbox7 {
            padding: 10px;
            background-color: #fff;
            border: 1px dotted #cbcbcb;
        }
        .txc-textbox8 {
            padding: 10px;
            background-color: #eee;
            border: 1px dotted #c1c1c1;
        }
        .txc-textbox9 {
            padding: 10px;
            background-color: #f2f2b8;
            border: 1px dotted #f3c534;
        }
        .txc-textbox10 {
            padding: 10px;
            background-color: #fedec7;
            border: 1px dotted #fe8943;
        }
        .txc-textbox11 {
            padding: 10px;
            background-color: #e7fdb5;
            border: 1px dotted #9fd331;
        }
        .txc-textbox12 {
            padding: 10px;
            background-color: #dbe8fb;
            border: 1px dotted #79a5e4;
        }
        .txc-textbox13 {
            padding: 10px;
            background-color: #fff;
            border: 1px solid #cbcbcb;
        }
        .txc-textbox14 {
            padding: 10px;
            background-color: #eee;
            border: 1px solid #c1c1c1;
        }
        .txc-textbox15 {
            padding: 10px;
            background-color: #f2f2b8;
            border: 1px solid #f3c534;
        }
        .txc-textbox16 {
            padding: 10px;
            background-color: #fedec7;
            border: 1px solid #fe8943;
        }
        .txc-textbox17 {
            padding: 10px;
            background-color: #e7fdb5;
            border: 1px solid #9fd331;
        }
        .txc-textbox18 {
            padding: 10px;
            background-color: #dbe8fb;
            border: 1px solid #79a5e4;
        }
        .txc-textbox19 {
            padding: 10px;
            background-color: #fff;
            border: 3px double #cbcbcb;
        }
        .txc-textbox20 {
            padding: 10px;
            background-color: #eee;
            border: 3px double #c1c1c1;
        }
        .txc-textbox21 {
            padding: 10px;
            background-color: #f2f2b8;
            border: 3px double #f3c534;
        }
        .txc-textbox22 {
            padding: 10px;
            background-color: #fedec7;
            border: 3px double #fe8943;
        }
        .txc-textbox23 {
            padding: 10px;
            background-color: #e7fdb5;
            border: 3px double #9fd331;
        }
        .txc-textbox24 {
            padding: 10px;
            background-color: #dbe8fb;
            border: 3px double #79a5e4;
        }
        /* content_wysiwyg */
        body,
        td,
        button {
            line-height: 1.5;
            font-size: 9pt;
            font-family: gulim, tahoma, sans-serif;
        }
        body {
            background: transparent;
            scrollbar-3dlight-color: #fff;
            scrollbar-arrow-color: #9f9f9f;
            scrollbar-darkshadow-color: #fff;
            scrollbar-face-color: #e6e6e6;
            scrollbar-highlight-color: #c3c3c3;
            scrollbar-shadow-color: #c3c3c3;
            scrollbar-track-color: #f3f3f3;
            margin: 0;
            padding: 8px;
        }
        a:hover,
        a:link,
        a:active,
        a:visited {
            text-decoration: none;
        }
        button {
            cursor: default;
            -moz-user-modify: read-only !important;
            -webkit-user-modify: read-only !important;
            -khtml-user-modify: read-only !important;
        }
        button a:hover,
        button a:link,
        button a:active,
        button a:visited {
            border: none;
        }
        blockquote {
            margin: 0;
        }
        .txc-media {
            border: 1px solid #eee;
            background: #f3f3f3 url(/editor/images/icon/editor/img_multi_icon.gif?v=2) no-repeat 50% 50%;
        }
        .txc-media-wmp {
            border: none;
            background: #000 url(/editor/images/icon/editor/img_multi_wmp.gif?v=2) no-repeat left bottom;
        }
        .txc-media-tvpot {
            border: none;
            background: #000;
        }
        /* editor */
        .tx-editor-container {
            clear: both;
            font-family: gulim, tahoma, sans-serif;
            font-size: 12px;
            line-height: 1.5;
            text-align: left;
            position: relative;
            zoom: 1;
        }
        .tx-editor-container ul,
        .tx-editor-container li {
            list-style: none outside none;
            margin: 0;
            padding: 0;
        }
        .tx-editor-container dl,
        .tx-editor-container dt,
        .tx-editor-container dd {
            float: none;
            margin: 0;
            padding: 0;
            width: auto;
        }
        .tx-editor-container img {
            border: none;
        }
        .tx-editor-container hr,
        .tx-editor-container h1,
        .tx-editor-container h2,
        .tx-editor-container h3,
        .tx-editor-container h4,
        .tx-editor-container h5,
        .tx-editor-container h6 {
            display: block;
        }
        .tx-toolbar {
            clear: both;
            background-color: #f8f8f8;
            border: 1px solid #cdcdcd;
            border-bottom: none;
            height: 30px;
        }
        .tx-toolbar-boundary {
            border: 1px solid #fff;
            padding: 0 0 0 5px;
            height: 28px;
        }
        .tx-toolbar-boundary .tx-tableedit {
            width: 10px;
            height: 18px;
            background: url(/editor/images/icon/editor/skin/06/tx_icon_20130320.gif) no-repeat;
            background-position: -89px -152px;
        }
        .tx-toolbar-table-boundary {
            border: 1px solid #fff;
            padding: 0 0 0 412px;
            height: 5px;
        }
        .tx-toolbar .tx-bar li {
            position: relative;
            z-index: 4;
        }
        .tx-toolbar .tx-bar-left {
            float: left;
            margin: 0 3px 0 0;
        }
        .tx-toolbar .tx-bar-right {
            float: right;
            margin: 0;
        }
        .tx-toolbar .tx-bar-empty {
            clear: left;
            margin: 0;
        }
        .tx-toolbar .tx-list {
            float: left;
            padding-top: 4px;
            padding-bottom: 0;
            height: 22px;
        }
        .tx-toolbar .tx-separator {
            float: left;
            width: 4px;
            height: 18px;
            overflow: hidden;
        }
        .tx-toolbar .tx-list-first,
        .tx-toolbar .tx-list-last {
            background-image: none !important;
        }
        .tx-toolbar .tx-disable a {
            cursor: default;
            filter: alpha(opacity=30);
            opacity: 0.3;
        }
        .tx-toolbar .tx-bar li a {
            color: #333;
            cursor: pointer;
            display: block;
            font-family: dotum, sans-serif;
            font-size: 12px;
            text-decoration: none;
        }
        .tx-toolbar-basic li.tx-list {
            z-index: 5;
        }
        .tx-toolbar-advanced {
            display: none;
        }
        .tx-sidebar {
            clear: both;
            background: #f8f8f8;
            border-width: 1px 1px 0;
            border-style: solid solid none;
            border-color: #d5d5d5 #cdcdcd;
            height: 30px;
        }
        .tx-sidebar-boundary {
            background: #f8f8f8;
            border: 1px solid #fff;
            padding: 0 0 0 7px;
            height: 28px;
        }
        .tx-toolbar .tx-bar li {
            position: relative;
            z-index: 6;
        }
        .tx-sidebar .tx-bar-left {
            float: left;
            margin: 1px 3px 0 0;
        }
        .tx-sidebar .tx-bar-right {
            float: right;
            margin: 0;
        }
        .tx-sidebar .tx-bar-empty {
            clear: left;
            margin: 0;
        }
        .tx-sidebar .tx-bar-middle div {
            background-image: url(/editor/images/icon/editor/skin/05/tx_btn_01.gif);
            background-position: -331px -97px;
            width: 3px;
            height: 30px;
            margin-top: -2px;
        }
        .tx-toolbar-advanced .tx-bar-middle div {
            background-image: url(/editor/images/icon/editor/skin/05/tx_btn_01.gif);
            background-position: -331px -97px;
            width: 3px;
            height: 30px;
            margin-top: -5px;
        }
        .tx-sidebar .tx-list {
            float: left;
            position: relative;
            z-index: 7;
        }
        .tx-sidebar .tx-bar-left {
            padding: 0;
        }
        .tx-sidebar .tx-list-first,
        .tx-sidebar .tx-list-last {
            background-image: none !important;
        }
        .tx-sidebar li.tx-list-extra {
            padding: 2px 2px 0 0;
        }
        .tx-sidebar .tx-disable a,
        .tx-sidebar ul.tx-disable {
            cursor: default;
            filter: alpha(opacity=30);
            opacity: 0.3;
        }
        .tx-nav-attach .tx-list {
            padding: 0 14px 0 0;
        }
        .tx-nav-search .tx-list {
            padding: 0 9px 0 4px;
        }
        .tx-bar-middle div {
            _position: absolute;
            _top: 0;
            _right: 0;
        }
        a.tx-icon {
            background: url(/editor/images/icon/editor/skin/06/tx_icon_20130320.gif);
            background-repeat: no-repeat;
            width: 21px;
            height: 22px;
            display: block;
            float: left;
            font-size: 0;
            line-height: 0;
            overflow: hidden;
            text-indent: -1000px;
        }
        a.tx-icon2 {
            background: url(/editor/images/icon/editor/skin/05/icon_add_table01.gif);
            background-repeat: no-repeat;
            width: 21px;
            height: 22px;
            display: block;
            float: left;
            font-size: 0;
            line-height: 0;
            overflow: hidden;
            text-indent: -1000px;
        }
        a.tx-icon3 {
            background: url(/editor/images/icon/editor/table/icon_design.gif);
            background-repeat: no-repeat;
            width: 21px;
            height: 22px;
            display: block;
            float: left;
            font-size: 0;
            line-height: 0;
            overflow: hidden;
            text-indent: -1000px;
        }
        a.tx-icon4 {
            background: url(/editor/images/icon/editor/table/icon_form.gif);
            background-repeat: no-repeat;
            width: 21px;
            height: 20px;
            display: block;
            float: left;
            font-size: 0;
            line-height: 0;
            overflow: hidden;
            text-indent: -1000px;
        }
        a.tx-text,
        .tx-searcher-title,
        .tx-switchtoggle a,
        .tx-switchtoggle-hovered a,
        .tx-switchtoggle-pushed a {
            background: url(/editor/images/icon/editor/skin/06/tx_text2.gif);
            background-repeat: no-repeat;
            height: 25px;
            display: block;
            float: left;
            font-size: 0;
            line-height: 0;
            overflow: hidden;
            text-indent: -1000px;
        }
        .tx-btn-lbg,
        .tx-btn-lbg-hovered,
        .tx-btn-lbg-pushed,
        .tx-btn-bg,
        .tx-btn-bg-hovered,
        .tx-btn-bg-pushed,
        .tx-btn-rbg,
        .tx-btn-rbg-hovered,
        .tx-btn-rbg-pushed,
        .tx-btn-lrbg,
        .tx-btn-lrbg-hovered,
        .tx-btn-lrbg-pushed,
        .tx-slt-tlbg,
        .tx-slt-tlbg-hovered,
        .tx-slt-tlbg-pushed,
        .tx-slt-tlbg-arrow-hovered,
        .tx-slt-tlbg-arrow-pushed,
        .tx-slt-tbg,
        .tx-slt-tbg-hovered,
        .tx-slt-tbg-pushed,
        .tx-slt-tbg-arrow-hovered,
        .tx-slt-tbg-arrow-pushed,
        .tx-slt-trbg,
        .tx-slt-trbg-hovered,
        .tx-slt-trbg-pushed,
        .tx-slt-trbg-arrow-hovered,
        .tx-slt-trbg-arrow-pushed,
        .tx-slt-blbg,
        .tx-slt-blbg-hovered,
        .tx-slt-blbg-pushed,
        .tx-slt-blbg-arrow-hovered,
        .tx-slt-blbg-arrow-pushed,
        .tx-slt-bbg,
        .tx-slt-bbg-hovered,
        .tx-slt-bbg-pushed,
        .tx-slt-bbg-arrow-hovered,
        .tx-slt-bbg-arrow-pushed,
        .tx-slt-brbg,
        .tx-slt-brbg-hovered,
        .tx-slt-brbg-pushed,
        .tx-slt-brbg-arrow-hovered,
        .tx-slt-brbg-arrow-pushed,
        .tx-slt-31bg,
        .tx-slt-31bg-hovered,
        .tx-slt-31bg-pushed,
        .tx-slt-31lbg,
        .tx-slt-31lbg-hovered,
        .tx-slt-31lbg-pushed,
        .tx-slt-31rbg,
        .tx-slt-31rbg-hovered,
        .tx-slt-31rbg-pushed,
        .tx-slt-70lbg,
        .tx-slt-70lbg-hovered,
        .tx-slt-70lbg-pushed,
        .tx-slt-70bg,
        .tx-slt-70bg-hovered,
        .tx-slt-70bg-pushed,
        .tx-slt-59bg,
        .tx-slt-59bg-hovered,
        .tx-slt-59bg-pushed,
        .tx-slt-42bg,
        .tx-slt-42bg-hovered,
        .tx-slt-42bg-pushed,
        .tx-slt-56bg,
        .tx-slt-56bg-hovered,
        .tx-slt-56bg-pushed,
        .tx-btn-nlrbg,
        .tx-btn-nlrbg-hovered,
        .tx-btn-nlrbg-pushed,
        .tx-btn-43lrbg,
        .tx-btn-43lrbg-hovered,
        .tx-btn-43lrbg-pushed,
        .tx-btn-52lrbg,
        .tx-btn-52lrbg-hovered,
        .tx-btn-52lrbg-pushed,
        .tx-btn-57lrbg,
        .tx-btn-57lrbg-hovered,
        .tx-btn-57lrbg-pushed,
        .tx-btn-71lrbg,
        .tx-btn-71lrbg-hovered,
        .tx-btn-71lrbg-pushed,
        .tx-btn-48lbg,
        .tx-btn-48lbg-hovered,
        .tx-btn-48lbg-pushed,
        .tx-btn-48rbg,
        .tx-btn-48rbg-hovered,
        .tx-btn-48rbg-pushed,
        .tx-btn-30lrbg,
        .tx-btn-30lrbg-hovered,
        .tx-btn-30lrbg-pushed,
        .tx-btn-46lrbg,
        .tx-btn-46lrbg-hovered,
        .tx-btn-46lrbg-pushed,
        .tx-btn-67lrbg,
        .tx-btn-67lrbg-hovered,
        .tx-btn-67lrbg-pushed,
        .tx-btn-49lbg,
        .tx-btn-49lbg-hovered,
        .tx-btn-49lbg-pushed,
        .tx-btn-49rbg,
        .tx-btn-49rbg-hovered,
        .tx-btn-49rbg-pushed,
        .tx-btn-58bg,
        .tx-btn-58bg-hovered,
        .tx-btn-58bg-pushed,
        .tx-btn-46bg,
        .tx-btn-46bg-hovered,
        .tx-btn-46bg-pushed {
            float: left;
            background: url(/editor/images/icon/editor/skin/05/tx_btn_01.gif);
            background-repeat: no-repeat;
        }
        .tx-btn-lbg {
            background-position: 0 0;
        }
        .tx-btn-lbg-hovered {
            background-position: 0 -32px;
        }
        .tx-btn-lbg-pushed {
            background-position: 0 -64px;
        }
        .tx-btn-bg {
            background-position: -21px 0;
        }
        .tx-btn-bg-hovered {
            background-position: -21px -32px;
        }
        .tx-btn-bg-pushed {
            background-position: -21px -64px;
        }
        .tx-btn-rbg {
            background-position: -42px 0;
        }
        .tx-btn-rbg-hovered {
            background-position: -42px -32px;
        }
        .tx-btn-rbg-pushed {
            background-position: -42px -64px;
        }
        .tx-btn-lrbg a,
        .tx-btn-lrbg-hovered a,
        .tx-btn-lrbg-pushed a {
            width: 22px;
        }
        .tx-btn-lrbg {
            background-position: -68px 0;
        }
        .tx-btn-lrbg-hovered {
            background-position: -68px -32px;
        }
        .tx-btn-lrbg-pushed {
            background-position: -68px -64px;
        }
        .tx-slt-tlbg {
            background-position: -95px 0;
        }
        .tx-slt-tlbg-hovered {
            background-position: -95px -32px;
        }
        .tx-slt-tlbg-pushed {
            background-position: -95px -64px;
        }
        .tx-slt-tlbg-arrow-hovered {
            background-position: -95px -96px;
        }
        .tx-slt-tlbg-arrow-pushed {
            background-position: -95px -128px;
        }
        .tx-slt-tbg {
            background-position: -127px 0;
        }
        .tx-slt-tbg-hovered {
            background-position: -127px -32px;
        }
        .tx-slt-tbg-pushed {
            background-position: -127px -64px;
        }
        .tx-slt-tbg-arrow-hovered {
            background-position: -127px -96px;
        }
        .tx-slt-tbg-arrow-pushed {
            background-position: -127px -128px;
        }
        .tx-slt-trbg {
            background-position: -158px 0;
        }
        .tx-slt-trbg-hovered {
            background-position: -158px -32px;
        }
        .tx-slt-trbg-pushed {
            background-position: -158px -64px;
        }
        .tx-slt-trbg-arrow-hovered {
            background-position: -158px -96px;
        }
        .tx-slt-trbg-arrow-pushed {
            background-position: -158px -128px;
        }
        .tx-slt-blbg {
            background-position: -194px 0;
        }
        .tx-slt-blbg-hovered {
            background-position: -194px -32px;
        }
        .tx-slt-blbg-pushed {
            background-position: -194px -64px;
        }
        .tx-slt-blbg-arrow-hovered {
            background-position: -194px -96px;
        }
        .tx-slt-blbg-arrow-pushed {
            background-position: -194px -128px;
        }
        .tx-slt-bbg {
            background-position: -224px 0;
        }
        .tx-slt-bbg-hovered {
            background-position: -224px -32px;
        }
        .tx-slt-bbg-pushed {
            background-position: -224px -64px;
        }
        .tx-slt-bbg-arrow-hovered {
            background-position: -224px -96px;
        }
        .tx-slt-bbg-arrow-pushed {
            background-position: -224px -128px;
        }
        .tx-slt-brbg {
            background-position: -257px 0;
        }
        .tx-slt-brbg-hovered {
            background-position: -257px -32px;
        }
        .tx-slt-brbg-pushed {
            background-position: -257px -64px;
        }
        .tx-slt-brbg-arrow-hovered {
            background-position: -257px -96px;
        }
        .tx-slt-brbg-arrow-pushed {
            background-position: -257px -128px;
        }
        .tx-slt-31bg a,
        .tx-slt-31bg-hovered a,
        .tx-slt-31bg-pushed a {
            width: 31px;
        }
        .tx-slt-31lbg a,
        .tx-slt-31lbg-hovered a,
        .tx-slt-31lbg-pushed a {
            width: 31px;
        }
        .tx-slt-31rbg a,
        .tx-slt-31rbg-hovered a,
        .tx-slt-31rbg-pushed a {
            width: 31px;
        }
        .tx-slt-31bg {
            background-position: -1291px 0;
        }
        .tx-slt-31bg-hovered {
            background-position: -1291px -32px;
        }
        .tx-slt-31bg-pushed {
            background-position: -1291px -64px;
        }
        .tx-slt-31lbg {
            background-position: -293px 0;
        }
        .tx-slt-31lbg-hovered {
            background-position: -293px -32px;
        }
        .tx-slt-31lbg-pushed {
            background-position: -293px -64px;
        }
        .tx-slt-31rbg {
            background-position: -324px 0;
        }
        .tx-slt-31rbg-hovered {
            background-position: -324px -32px;
        }
        .tx-slt-31rbg-pushed {
            background-position: -324px -64px;
        }
        .tx-slt-70lbg a,
        .tx-slt-70lbg-hovered a,
        .tx-slt-70lbg-pushed a {
            width: 70px;
            height: 22px;
            overflow-y: hidden;
        }
        .tx-slt-70lbg a span,
        .tx-slt-70lbg-hovered a span,
        .tx-slt-70lbg-pushed a span {
            display: block;
            padding: 2px 12px 3px 5px;
        }
        .tx-slt-70lbg {
            background-position: -359px -96px;
        }
        .tx-slt-70lbg-hovered {
            background-position: -359px -128px;
        }
        .tx-slt-70lbg-pushed {
            background-position: -359px -160px;
        }
        .tx-slt-70bg a,
        .tx-slt-70bg-hovered a,
        .tx-slt-70bg-pushed a {
            width: 70px;
            height: 22px;
            overflow-y: hidden;
        }
        .tx-slt-70bg a span,
        .tx-slt-70bg-hovered a span,
        .tx-slt-70bg-pushed a span {
            display: block;
            padding: 2px 12px 3px 5px;
        }
        .tx-slt-70bg {
            background-position: -359px 0;
        }
        .tx-slt-70bg-hovered {
            background-position: -359px -32px;
        }
        .tx-slt-70bg-pushed {
            background-position: -359px -64px;
        }
        .tx-slt-59bg a,
        .tx-slt-59bg-hovered a,
        .tx-slt-59bg-pushed a {
            width: 61px;
            height: 22px;
            overflow-y: hidden;
        }
        .tx-slt-59bg a span,
        .tx-slt-59bg-hovered a span,
        .tx-slt-59bg-pushed a span {
            display: block;
            padding: 2px 12px 3px 5px;
        }
        .tx-slt-59bg {
            background-position: -434px 0;
        }
        .tx-slt-59bg-hovered {
            background-position: -434px -32px;
        }
        .tx-slt-59bg-pushed {
            background-position: -434px -64px;
        }
        .tx-slt-42bg a,
        .tx-slt-42bg-hovered a,
        .tx-slt-42bg-pushed a {
            width: 42px;
            height: 22px;
            overflow-y: hidden;
        }
        .tx-slt-42bg a span,
        .tx-slt-42bg-hovered a span,
        .tx-slt-42bg-pushed a span {
            display: block;
            padding: 2px 12px 3px 5px;
        }
        .tx-slt-42bg {
            background-position: -499px 0;
        }
        .tx-slt-42bg-hovered {
            background-position: -499px -32px;
        }
        .tx-slt-42bg-pushed {
            background-position: -499px -64px;
        }
        .tx-slt-56bg a,
        .tx-slt-56bg-hovered a,
        .tx-slt-56bg-pushed a {
            width: 56px;
            height: 22px;
            overflow-y: hidden;
        }
        .tx-slt-56bg a span,
        .tx-slt-56bg-hovered a span,
        .tx-slt-56bg-pushed a span {
            display: block;
            padding: 2px 12px 3px 5px;
        }
        .tx-slt-56bg {
            background-position: -1363px 0;
        }
        .tx-slt-56bg-hovered {
            background-position: -1363px -32px;
        }
        .tx-slt-56bg-pushed {
            background-position: -1363px -64px;
        }
        .tx-btn-nlrbg a,
        .tx-btn-nlrbg-hovered a,
        .tx-btn-nlrbg-pushed a {
            width: 12px;
        }
        .tx-btn-nlrbg {
            background-position: -546px 0;
        }
        .tx-btn-nlrbg-hovered {
            background-position: -546px -32px;
        }
        .tx-btn-nlrbg-pushed {
            background-position: -546px -64px;
        }
        .tx-btn-43lrbg a,
        .tx-btn-43lrbg-hovered a,
        .tx-btn-43lrbg-pushed a {
            width: 43px;
        }
        .tx-btn-43lrbg {
            background-position: -563px 0;
        }
        .tx-btn-43lrbg-hovered {
            background-position: -563px -32px;
        }
        .tx-btn-43lrbg-pushed {
            background-position: -563px -64px;
        }
        .tx-btn-52lrbg a,
        .tx-btn-52lrbg-hovered a,
        .tx-btn-52lrbg-pushed a {
            width: 52px;
        }
        .tx-btn-52lrbg {
            background-position: -611px 0;
        }
        .tx-btn-52lrbg-hovered {
            background-position: -611px -32px;
        }
        .tx-btn-52lrbg-pushed {
            background-position: -611px -64px;
        }
        .tx-btn-57lrbg a,
        .tx-btn-57lrbg-hovered a,
        .tx-btn-57lrbg-pushed a {
            width: 57px;
        }
        .tx-btn-57lrbg {
            background-position: -668px 0;
        }
        .tx-btn-57lrbg-hovered {
            background-position: -668px -32px;
        }
        .tx-btn-57lrbg-pushed {
            background-position: -668px -64px;
        }
        .tx-btn-71lrbg a,
        .tx-btn-71lrbg-hovered a,
        .tx-btn-71lrbg-pushed a {
            width: 71px;
        }
        .tx-btn-71lrbg {
            background-position: -730px 0;
        }
        .tx-btn-71lrbg-hovered {
            background-position: -730px -32px;
        }
        .tx-btn-71lrbg-pushed {
            background-position: -730px -64px;
        }
        .tx-btn-48lbg a,
        .tx-btn-48lbg-hovered a,
        .tx-btn-48lbg-pushed a {
            width: 48px;
        }
        .tx-btn-48lbg {
            background-position: -806px 0;
        }
        .tx-btn-48lbg-hovered {
            background-position: -806px -32px;
        }
        .tx-btn-48lbg-pushed {
            background-position: -806px -64px;
        }
        .tx-btn-48rbg a,
        .tx-btn-48rbg-hovered a,
        .tx-btn-48rbg-pushed a {
            width: 48px;
        }
        .tx-btn-48rbg {
            background-position: -854px 0;
        }
        .tx-btn-48rbg-hovered {
            background-position: -854px -32px;
        }
        .tx-btn-48rbg-pushed {
            background-position: -854px -64px;
        }
        .tx-btn-30lrbg a,
        .tx-btn-30lrbg-hovered a,
        .tx-btn-30lrbg-pushed a {
            width: 30px;
        }
        .tx-btn-30lrbg {
            background-position: -908px 0;
        }
        .tx-btn-30lrbg-hovered {
            background-position: -908px -32px;
        }
        .tx-btn-30lrbg-pushed {
            background-position: -908px -64px;
        }
        .tx-btn-46lrbg a,
        .tx-btn-46lrbg-hovered a,
        .tx-btn-46lrbg-pushed a {
            width: 46px;
        }
        .tx-btn-46lrbg {
            background-position: -943px 0;
        }
        .tx-btn-46lrbg-hovered {
            background-position: -943px -32px;
        }
        .tx-btn-46lrbg-pushed {
            background-position: -943px -64px;
        }
        .tx-btn-67lrbg a,
        .tx-btn-67lrbg-hovered a,
        .tx-btn-67lrbg-pushed a {
            width: 67px;
        }
        .tx-btn-67lrbg {
            background-position: -994px 0;
        }
        .tx-btn-67lrbg-hovered {
            background-position: -994px -32px;
        }
        .tx-btn-67lrbg-pushed {
            background-position: -994px -64px;
        }
        .tx-btn-49lbg a,
        .tx-btn-49lbg-hovered a,
        .tx-btn-49lbg-pushed a {
            width: 49px;
        }
        .tx-btn-49lbg {
            background-position: -1084px 0;
        }
        .tx-btn-49lbg-hovered {
            background-position: -1084px -32px;
        }
        .tx-btn-49lbg-pushed {
            background-position: -1084px -64px;
        }
        .tx-btn-58bg a,
        .tx-btn-58bg-hovered a,
        .tx-btn-58bg-pushed a {
            width: 58px;
        }
        .tx-btn-58bg {
            background-position: -1133px 0;
        }
        .tx-btn-58bg-hovered {
            background-position: -1133px -32px;
        }
        .tx-btn-58bg-pushed {
            background-position: -1133px -64px;
        }
        .tx-btn-46bg a,
        .tx-btn-46bg-hovered a,
        .tx-btn-46bg-pushed a {
            width: 46px;
        }
        .tx-btn-46bg {
            background-position: -1191px 0;
        }
        .tx-btn-46bg-hovered {
            background-position: -1191px -32px;
        }
        .tx-btn-46bg-pushed {
            background-position: -1191px -64px;
        }
        .tx-btn-49rbg a,
        .tx-btn-49rbg-hovered a,
        .tx-btn-49rbg-pushed a {
            width: 49px;
        }
        .tx-btn-49rbg {
            background-position: -1237px 0;
        }
        .tx-btn-49rbg-hovered {
            background-position: -1237px -32px;
        }
        .tx-btn-49rbg-pushed {
            background-position: -1237px -64px;
        }
        a.tx-arrow {
            width: 10px;
            height: 21px;
        }
        a.tx-arrow {
            float: left;
            display: block;
            width: 10px;
            height: 21px;
            font-size: 0;
            line-height: 0;
            text-indent: -1000px;
            overflow: hidden;
        }
        em.tx-itsnew {
            display: block;
            width: 13px;
            height: 14px;
            background: url(/editor/images/icon/editor/ic_new.gif?v=2) no-repeat 0 0;
            position: absolute;
            top: -7px;
            right: 3px;
            font-size: 0;
            line-height: 0;
            overflow: hidden;
            text-indent: -1000px;
        }
        .tx-text em.tx-itsnew {
            right: 11px;
        }
        .tx-icon em.tx-itsnew {
            right: 1px;
        }
        .tx-menu {
            display: none;
            border: 1px solid #bababa;
            background: #fff;
            padding: 1px;
            z-index: 15000;
            position: absolute;
            left: 0;
            top: 28px;
        }
        .tx-menu ul {
            margin: 0;
        }
        .tx-menu .tx-menu-inner {
            background: #f9f9f9;
        }
        ul.tx-menu-list {
            background: #fff;
            margin: 0;
        }
        li.tx-menu-list-item {
            color: #333;
            font-size: 12px;
            font-family: dotum, sans-serif;
            list-style: none;
            white-space: nowrap;
            -moz-user-select: none;
            -khtml-user-select: none;
        }
        li.tx-menu-list-item a {
            display: block;
            padding: 3px 7px;
            white-space: nowrap;
            text-decoration: none;
            color: #555;
            -moz-outline: 0 none;
            outline: 0 none;
            cursor: pointer;
            clear: both;
        }
        li.tx-menu-list-item a:hover {
            background-color: #c6cffe;
            text-decoration: none;
        }
        li.tx-menu-list-item a span.tx-txt {
            color: #999;
            line-height: 1.4;
        }
        ul.tx-menu-favlist {
            border-bottom: 1px solid #ececec;
        }
        ul.tx-menu-matrix-title {
            width: 100%;
            margin-top: 2px;
            height: 18px;
        }
        ul.tx-menu-matrix-title li {
            float: left;
            padding: 0 10px 0 5px;
            background: url(/editor/images/icon/editor/index01.gif?v=2) no-repeat 100% 4px;
            margin-right: 4px;
        }
        ul.tx-menu-matrix-title li a {
            color: #666;
            font-family: dotum, sans-serif;
            font-size: 11px;
            cursor: pointer;
        }
        ul.tx-menu-matrix-title li.tx-selected {
            color: #333;
            font-weight: bold;
        }
        .tx-colorpallete {
            display: none;
            border: 1px solid #bababa;
            background: #fbfbfb;
            width: 195px;
            padding: 0;
            z-index: 15000;
            position: absolute;
        }
        .tx-colorpallete .tx-menu-inner {
            background: #f9f9f9;
            padding: 7px 0 7px 7px !important;
        }
        .tx-colorpallete ul.tx-pallete-text-list {
            clear: both;
            height: 84px;
            margin-bottom: 6px;
        }
        .tx-colorpallete ul.tx-pallete-text-list li {
            width: 59px;
            height: 16px;
            float: left;
            margin: 0 2px 1px 0;
            cursor: pointer;
        }
        .tx-colorpallete ul.tx-pallete-text-list li a {
            text-decoration: none;
            padding: 0;
            margin-left: 4px;
            font-size: 12px;
        }
        .tx-colorpallete ul.tx-pallete-text-list li a:hover {
            text-decoration: underline;
            background: none;
        }
        .tx-colorpallete ul.tx-pallete-thumb-list {
            clear: both;
            height: 96px;
            list-style: none;
            margin: 0;
        }
        .tx-colorpallete ul.tx-pallete-thumb-list li {
            float: left;
            margin: 0 1px 1px 0;
            width: 12px;
            height: 12px;
            cursor: pointer;
        }
        .tx-colorpallete ul.tx-pallete-thumb-list li.tx-menu-list-item {
            width: 12px;
            height: 12px;
        }
        .tx-colorpallete div.tx-pallete-buttons {
            clear: both;
            height: 12px;
            margin: 6px 0 0;
        }
        .tx-colorpallete div.tx-pallete-buttons a {
            display: block;
            text-indent: -1000em;
            overflow: hidden;
        }
        .tx-colorpallete div.tx-pallete-buttons p.tx-pallete-revert {
            float: left;
            margin: 0;
        }
        .tx-colorpallete div.tx-pallete-buttons p.tx-pallete-revert a {
            width: 13px;
            height: 12px;
            background: url(/editor/images/icon/editor/btn_revert.gif?v=2) no-repeat;
        }
        .tx-colorpallete div.tx-pallete-buttons p.tx-pallete-more {
            float: right;
            margin: 1px 6px 0 0;
        }
        .tx-colorpallete div.tx-pallete-buttons p.tx-pallete-more a.tx-more-down {
            width: 36px;
            height: 10px;
            background: url(/editor/images/icon/editor/btn_a_spread.gif?v=2) no-repeat;
        }
        .tx-colorpallete div.tx-pallete-buttons p.tx-pallete-more a.tx-more-up {
            width: 28px;
            height: 10px;
            background: url(/editor/images/icon/editor/btn_a_fold.gif?v=2) no-repeat;
        }
        .tx-colorpallete .tx-pallete-picker {
            display: none;
            clear: both;
            margin-top: 7px;
            height: 128px;
        }
        .tx-colorpallete p.tx-pallete-input {
            margin: 0 7px 0 0;
            clear: both;
            height: 21px;
            border-bottom: 1px solid #ececec;
        }
        .tx-colorpallete p.tx-pallete-input span {
            float: left;
            margin-right: 3px;
            width: 73px;
            height: 14px;
            border: 1px solid #d9d9d9;
            background: #ed1f1f;
        }
        .tx-colorpallete p.tx-pallete-input input {
            float: left;
            margin-right: 4px;
            width: 62px;
            height: 12px;
            border: 1px solid #a7a7a7;
            border-right-color: #eaeaea;
            border-bottom-color: #eaeaea;
            color: #333;
        }
        .tx-colorpallete p.tx-pallete-input a {
            float: right;
            width: 33px;
            height: 16px;
            background: url(/editor/images/icon/editor/btn_l_input_1.gif) no-repeat;
            text-indent: -1000em;
            cursor: pointer;
        }
        .tx-colorpallete .tx-pallete-picker .tx-pallete-pickerbox {
            float: left;
            margin-bottom: 5px;
            border: 1px solid #d9d9d9;
            padding: 4px;
            display: inline;
        }
        .tx-colorpallete .tx-pallete-picker .tx-chromabar {
            float: left;
            position: relative;
            width: 150px;
            height: 120px;
            cursor: crosshair;
            margin-right: 4px;
            background: #f00 url(/editor/images/icon/editor/img_color_w.png) no-repeat;
        }
        .tx-colorpallete .tx-pallete-picker .tx-huebar {
            float: left;
            position: relative;
            width: 18px;
            height: 120px;
            cursor: crosshair;
            overflow: hidden;
            background: url(/editor/images/icon/editor/img_colorbar_w.gif) no-repeat;
        }
        * html .tx-colorpallete .tx-pallete-picker .tx-chromabar {
            background: none;
            filter: progid:DXImageTransform.Microsoft.AlphaImageLoader(src='/editor/images/icon/editor/img_color_w.png?v=2',sizingMethod='scale');
        }
        .tx-canvas {
            clear: both;
            border: 1px solid #b5b5b5;
            border-right-color: #cdcdcd;
            border-left-color: #cdcdcd;
            position: relative;
            font-size: 0;
        }
        .tx-daumtrans {
            position: absolute;
            top: -1000px;
            left: -1000px;
        }
        .tx-canvas .tx-holder {
            display: none;
            font-size: 0 !important;
            zoom: 1;
        }
        .tx-canvas iframe,
        .tx-canvas textarea {
            width: 100%;
            scrollbar-3dlight-color: #fff;
            scrollbar-arrow-color: #9f9f9f;
            scrollbar-darkshadow-color: #fff;
            scrollbar-face-color: #e6e6e6;
            scrollbar-highlight-color: #c3c3c3;
            scrollbar-shadow-color: #c3c3c3;
            scrollbar-track-color: #f3f3f3;
        }
        .tx-canvas iframe {
            height: 400px;
        }
        .tx-canvas textarea {
            height: 398px;
            overflow: auto;
            border: none;
            background: #fff;
            color: #000;
            padding: 0;
            font-family: dotum, sans-serif;
            font-size: 12px;
            line-height: 1.6;
            word-break: break-all;
            display: block;
        }
        div.tx-canvas div.tx-wysiwyg-padding {
            height: 100%;
            width: 0;
            left: 0;
            position: absolute;
            top: 0;
            opacity: 0.3;
            filter: alpha(opacity=30);
            overflow: hidden;
        }
        div.tx-canvas div.tx-wysiwyg-padding-divL {
            float: right;
            width: 26px;
            height: 26px;
            margin-top: 3px;
            margin-right: 2px;
        }
        div.tx-canvas div.tx-wysiwyg-padding-divR {
            float: left;
            width: 26px;
            height: 26px;
            margin-top: 3px;
            margin-left: 2px;
        }
        div.tx-canvas div.tx-wysiwyg-padding-divL {
            margin-right: 0;
        }
        div.tx-canvas div.tx-wysiwyg-padding-divR {
            margin-left: 0;
        }
        ul.tx-bar-vline-left {
            background: transparent url(/editor/images/icon/editor/index03.gif?v=2) no-repeat scroll left 9px;
            margin: 0 0 0 5px;
            padding: 0 0 0 6px;
        }
        ul.tx-bar-vline-right {
            background: transparent url(/editor/images/icon/editor/index03.gif?v=2) no-repeat scroll right 9px;
            margin: 0 6px 0 3px;
            padding: 0 5px 0 0;
        }
        div.tx-loading {
            position: absolute;
            z-index: 200;
            width: 100%;
            height: 29px;
            top: 0;
            left: 0;
            text-align: center;
            padding: 8px 0 0;
            font-size: 0;
        }
        * html .tx-loading div {
            background: none;
            filter: progid:DXImageTransform.Microsoft.AlphaImageLoader(src='/editor/images/icon/editor/loading2.png?v=2',sizingMethod='image');
            width: 113px;
            height: 21px;
        }
        * html .tx-loading img {
            display: none;
        }
        .tx-side-bi {
            margin: 0 0 5px 0;
        }
        * html .tx-side-bi .tx-side-inner-bi img {
            height: 1px;
            width: 1px;
            filter: progid:DXImageTransform.Microsoft.AlphaImageLoader(src='/editor/images/icon/editor/editor_bi.png?v=2');
        }
        .tx-switcher-menu {
            width: 57px;
        }
        .tx-switchtoggle a {
            width: 48px;
            background-position: 0 -80px;
            margin: 0;
        }
        .tx-switchtoggle-hovered a {
            width: 48px;
            background-position: 0 -103px;
            margin: 0;
        }
        .tx-switchtoggle-pushed a {
            width: 48px;
            background-position: -58px -80px;
            margin: 0;
        }
        .tx-switchtoggle a,
        .tx-switchtoggle-hovered a,
        .tx-switchtoggle-pushed a {
            width: 52px;
            height: 25px;
            text-indent: -100em;
            overflow: hidden;
            display: block;
            font-size: 12px;
        }
        .tx-switchtoggle a,
        .tx-switchtoggle-hovered a,
        .tx-switchtoggle-pushed a {
            background-image: url(/editor/images/icon/editor/skin/06/tx_text2.gif);
            background-repeat: no-repeat;
            font-size: 0;
            line-height: 0;
            text-indent: -9999em;
            overflow: hidden;
            display: block;
        }
        .tx-fontfamily a:hover {
            text-decoration: none;
        }
        .tx-fontfamily span {
            line-height: 1.5;
            word-break: break-all;
        }
        .tx-fontfamily-menu {
            width: 168px;
        }
        .tx-fontfamily-menu .tx-menu-list-item a {
            height: 18px;
        }
        .tx-fontfamily-menu .tx-menu-list .tx-gulim {
            font-family: gulim, "굴림";
        }
        .tx-fontfamily-menu .tx-menu-list .tx-batang {
            font-family: batang, "바탕";
        }
        .tx-fontfamily-menu .tx-menu-list .tx-dotum {
            font-family: dotum, "돋움";
        }
        .tx-fontfamily-menu .tx-menu-list .tx-gungseo {
            font-family: gungseo, "궁서";
        }
        .tx-fontfamily-menu .tx-menu-list .tx-arial {
            font-family: Arial, Helvetica, sans-serif;
        }
        .tx-fontfamily-menu .tx-menu-list .tx-verdana {
            font-family: Verdana, Geneva, sans-serif;
        }
        .tx-fontfamily-menu .tx-menu-list .tx-courier-new {
            font-family: "Courier New", Courier, monospace;
        }
        .tx-fontsize {
            padding-right: 0;
        }
        .tx-fontsize a:hover {
            text-decoration: none;
            font-family: dotum, sans-serif;
        }
        .tx-fontsize span {
            line-height: 1.5;
        }
        .tx-fontsize-menu {
            width: 322px;
        }
        .tx-fontsize-menu li.tx-menu-list-item a {
            line-height: 100%;
            width: auto;
            height: auto;
        }
        .tx-fontsize-menu li a.tx-8pt {
            font-size: 8pt;
        }
        .tx-fontsize-menu li a.tx-9pt {
            font-size: 9pt;
        }
        .tx-fontsize-menu li a.tx-10pt {
            font-size: 10pt;
        }
        .tx-fontsize-menu li a.tx-11pt {
            font-size: 11pt;
        }
        .tx-fontsize-menu li a.tx-12pt {
            font-size: 12pt;
        }
        .tx-fontsize-menu li a.tx-14pt {
            font-size: 14pt;
        }
        .tx-fontsize-menu li a.tx-18pt {
            font-size: 18pt;
        }
        .tx-fontsize-menu li a.tx-24pt {
            font-size: 24pt;
        }
        .tx-fontsize-menu li a.tx-36pt {
            font-size: 36pt;
        }
        .tx-bold a.tx-icon {
            background-position: -24px -9px;
        }
        .tx-underline a.tx-icon {
            background-position: -45px -9px;
        }
        .tx-italic a.tx-icon {
            background-position: -65px -9px;
        }
        .tx-strike a.tx-icon {
            background-position: -85px -9px;
        }
        .tx-forecolor a.tx-icon {
            background-position: -105px -9px;
        }
        .tx-forecolor-menu {
            width: 195px;
        }
        .tx-backcolor a.tx-icon {
            background-position: -124px -10px;
        }
        .tx-alignleft a.tx-icon {
            background-position: -24px -30px;
        }
        .tx-selected-image .tx-alignleft a.tx-icon {
            background-position: -83px -130px;
        }
        .tx-alignright a.tx-icon {
            background-position: -65px -30px;
        }
        .tx-selected-image .tx-alignright a.tx-icon {
            background-position: -24px -130px;
        }
        .tx-aligncenter a.tx-icon {
            background-position: -44px -30px;
        }
        .tx-selected-image .tx-aligncenter a.tx-icon {
            background-position: -45px -130px;
        }
        .tx-alignfull a.tx-icon {
            background-position: -85px -30px;
        }
        .tx-selected-image .tx-alignfull a.tx-icon {
            background-position: -65px -130px;
        }
        .tx-specialchar a.tx-icon {
            background-position: -105px -90px;
        }
        .tx-specialchar-menu div.tx-menu-inner {
            padding: 7px;
            background: #f9f9f9;
        }
        .tx-specialchar-menu ul.tx-menu-matrix-title {
            width: 460px;
        }
        .tx-specialchar-menu div.tx-menu-matrix-list {
            display: none;
            border-collapse: collapse;
            margin-top: 6px;
            background: #fff;
        }
        .tx-specialchar-menu div.tx-menu-matrix-list table {
            border-collapse: collapse;
            margin-top: 0;
            width: 460px;
        }
        .tx-specialchar-menu div.tx-menu-matrix-list td {
            border: 1px solid #e5e5e5;
            padding: 0;
            width: 22px;
            height: 20px;
        }
        .tx-specialchar-menu div.tx-menu-matrix-list td span {
            display: block;
            width: 18px;
            height: 14px;
            text-align: center;
            color: #333;
            font-family: gulim, tahoma, sans-serif;
            font-size: 12px;
            line-height: 1.4;
            padding-top: 2px;
            border: 2px solid #fff;
            cursor: pointer;
        }
        .tx-specialchar-menu div.tx-menu-matrix-list td span.tx-item-hovered {
            color: #333;
            border: 2px solid #768fbd;
        }
        .tx-specialchar-menu dl.tx-menu-matrix-input {
            width: 460px;
            margin-top: 8px;
            height: 22px;
        }
        .tx-specialchar-menu dl.tx-menu-matrix-input dt {
            float: left;
            padding: 0 6px 0 0;
        }
        .tx-specialchar-menu dl.tx-menu-matrix-input dd {
            float: left;
        }
        .tx-specialchar-menu dl.tx-menu-matrix-input dt span {
            color: #333;
            font-size: 11px;
            font-family: dotum, sans-serif;
            padding-right: 6px;
        }
        .tx-specialchar-menu dl.tx-menu-matrix-input dd input {
            color: #666;
            width: 278px;
            height: 16px;
            padding: 0;
            border: 1px solid #cacaca;
        }
        .tx-specialchar-menu dl.tx-menu-matrix-input dd .tx-menu-btn-confirm {
            margin-left: 5px;
            cursor: pointer;
        }
        .tx-specialchar-menu dl.tx-menu-matrix-input dd .tx-menu-btn-cancel {
            margin-left: 3px;
            cursor: pointer;
        }
        .tx-link a.tx-icon {
            background-position: -26px -70px;
        }
        .tx-link-menu {
            width: 238px;
        }
        .tx-link-menu div.tx-menu-inner {
            padding: 10px 10px 0;
            color: #666;
            font-size: 11px;
            font-family: dotum, sans-serif;
            letter-spacing: -1;
        }
        .tx-link-menu dt {
            text-align: center;
            font-weight: normal;
            padding-bottom: 11px;
        }
        .tx-link-menu dd {
            text-align: center;
            padding: 0;
        }
        .tx-link-menu input.tx-text-input {
            width: 216px;
            height: 15px;
            font-size: 11px;
            font-family: dotum, sans-serif;
            color: #666;
            border: 1px solid #cacaca;
            padding: 3px 2px 2px;
            margin-bottom: 5px;
        }
        * html .tx-link-menu p input {
            height: 20px;
        }
        .tx-link-menu dd.tx-rp {
            text-align: left;
            padding: 0;
        }
        .tx-link-menu dd.tx-rp span {
            margin-right: 20px;
        }
        .tx-link-menu dd.tx-rp input {
            margin: 0 1px 2px 0;
            vertical-align: middle;
        }
        .tx-link-menu dd.tx-rp span.tx-text {
            margin-right: 0;
            position: relative;
        }
        .tx-link-menu dd.tx-rp span.tx-first {
            margin-right: 20px;
        }
        .tx-hr hr {
            display: block;
        }
        .tx-link-menu hr {
            border: 1px solid #eaeaea;
            overflow: visible;
            margin-bottom: 6px;
        }
        * + html body .tx-link-menu hr {
            margin-bottom: 0;
        }
        *html .tx-link-menu hr {
            margin-bottom: 0;
        }
        .tx-link-menu img {
            cursor: pointer;
            margin: 0 4px 0 0;
        }
        * + html body .tx-link-menu dd img {
            margin: 0 4px 5px 0;
        }
        *html .tx-link-menu dd img {
            margin: 0 4px 5px 0;
        }
        .tx-ordered a.tx-icon {
            background-position: -105px -30px;
        }
        .tx-unordered a.tx-icon {
            background-position: -124px -30px;
        }
        .tx-styledlist a.tx-icon {
            width: 21px;
        }
        .tx-styledlist a.tx-icon {
            background-position: -105px -30px;
        }
        .tx-styledlist a.tx-styledlist-0 {
            background-position: -125px -150px;
        }
        .tx-styledlist a.tx-styledlist-1 {
            background-position: -125px -30px;
        }
        .tx-styledlist a.tx-styledlist-2 {
            background-position: -25px -50px;
        }
        .tx-styledlist a.tx-styledlist-3 {
            background-position: -105px -30px;
        }
        .tx-styledlist a.tx-styledlist-4 {
            background-position: -45px -50px;
        }
        .tx-styledlist a.tx-styledlist-5 {
            background-position: -65px -50px;
        }
        .tx-styledlist-menu {
            width: 25px;
        }
        .tx-styledlist-menu li.tx-menu-list-item a {
            background-image: url(/editor/images/icon/editor/skin/06/tx_icon_20130320.gif);
            background-repeat: no-repeat;
            height: 18px;
            text-indent: -9999em;
        }
        .tx-styledlist-menu li.tx-menu-list-item a.tx-styledlist-0 {
            background-position: -122px -149px;
        }
        .tx-styledlist-menu li.tx-menu-list-item a.tx-styledlist-1 {
            background-position: -122px -29px;
        }
        .tx-styledlist-menu li.tx-menu-list-item a.tx-styledlist-2 {
            background-position: -22px -49px;
        }
        .tx-styledlist-menu li.tx-menu-list-item a.tx-styledlist-3 {
            background-position: -102px -29px;
        }
        .tx-styledlist-menu li.tx-menu-list-item a.tx-styledlist-4 {
            background-position: -42px -49px;
        }
        .tx-styledlist-menu li.tx-menu-list-item a.tx-styledlist-5 {
            background-position: -62px -49px;
        }
        .tx-cellslineheight-menu {
            width: 100px;
        }
        .tx-cellslineheight-menu li.tx-menu-list-item a {
            background-image: url(/editor/images/icon/editor/skin/05/icon_table_layer02.gif);
            background-repeat: no-repeat;
            height: 18px;
            text-indent: -9999em;
        }
        .tx-cellslineheight-menu li.tx-menu-list-item a.tx-cellslineheight-0 {
            background-position: -2px 0;
        }
        .tx-cellslineheight-menu li.tx-menu-list-item a.tx-cellslineheight-1 {
            background-position: -2px 0;
        }
        .tx-cellslineheight-menu li.tx-menu-list-item a.tx-cellslineheight-2 {
            background-position: -2px -21px;
        }
        .tx-cellslineheight-menu li.tx-menu-list-item a.tx-cellslineheight-3 {
            background-position: -2px -42px;
        }
        .tx-cellslineheight-menu li.tx-menu-list-item a.tx-cellslineheight-4 {
            background-position: -2px -62px;
        }
        .tx-cellslineheight-menu li.tx-menu-list-item a.tx-cellslineheight-5 {
            background-position: -2px -81px;
        }
        .tx-cellslineheight-menu li.tx-menu-list-item a.tx-cellslineheight-6 {
            background-position: -2px -102px;
        }
        .tx-cellslineheight-menu li.tx-menu-list-item a.tx-cellslineheight-7 {
            background-position: -2px -123px;
        }
        .tx-cellslinestyle-menu {
            width: 100px;
        }
        .tx-cellslinestyle-menu li.tx-menu-list-item a {
            background-image: url(/editor/images/icon/editor/skin/05/icon_table_layer02.gif);
            background-repeat: no-repeat;
            height: 17px;
            text-indent: -9999em;
        }
        .tx-cellslinestyle-menu li.tx-menu-list-item a.tx-cellslinestyle-0 {
            background-position: -2px 3px;
        }
        .tx-cellslinestyle-menu li.tx-menu-list-item a.tx-cellslinestyle-1 {
            background-position: -2px -144px;
        }
        .tx-cellslinestyle-menu li.tx-menu-list-item a.tx-cellslinestyle-2 {
            background-position: -2px -168px;
        }
        .tx-cellslinestyle-menu li.tx-menu-list-item a.tx-cellslinestyle-3 {
            background-position: -2px -189px;
        }
        .tx-cellslinestyle-menu li.tx-menu-list-item a.tx-cellslinestyle-4 {
            background-position: -2px -211px;
        }
        .tx-cellsoutline-menu {
            width: 112px;
        }
        .tx-cellsoutline-menu li.tx-menu-list-item a {
            background-image: url(/editor/images/icon/editor/skin/05/icon_table_layer01.gif);
            background-repeat: no-repeat;
            height: 19px;
            text-indent: 10px;
            padding: 3px 0 1px 15px;
        }
        .tx-cellsoutline-menu li.tx-menu-list-item a.tx-cellsoutline-1 {
            background-position: -5px -184px;
        }
        .tx-cellsoutline-menu li.tx-menu-list-item a.tx-cellsoutline-2 {
            background-position: -5px -206px;
        }
        .tx-cellsoutline-menu li.tx-menu-list-item a.tx-cellsoutline-3 {
            background-position: -5px -227px;
        }
        .tx-cellsoutline-menu li.tx-menu-list-item a.tx-cellsoutline-4 {
            background-position: -5px -248px;
        }
        .tx-cellsoutline-menu li.tx-menu-list-item a.tx-cellsoutline-5 {
            background-position: -5px -269px;
        }
        .tx-cellsoutline-menu li.tx-menu-list-item a.tx-cellsoutline-6 {
            background-position: -5px -290px;
        }
        .tx-cellsoutline-menu li.tx-menu-list-item a.tx-cellsoutline-7 {
            background-position: -5px -311px;
        }
        .tx-cellsoutline-menu li.tx-menu-list-item a.tx-cellsoutline-8 {
            background-position: -5px -331px;
        }
        .tx-mergecells-menu {
            width: 68px;
        }
        .tx-mergecells-menu li.tx-menu-list-item a {
            background-image: url(/editor/images/icon/editor/skin/05/icon_table_layer01.gif);
            background-repeat: no-repeat;
            height: 17px;
            text-indent: 20px;
            width: 55px;
            display: block;
            border: 0 none #fff;
        }
        .tx-mergecells-menu li.tx-menu-list-item a.tx-item-hovered {
            color: #333;
            border: 2px solid #768fbd;
        }
        .tx-mergecells-menu li.tx-menu-list-item a.tx-mergecells-1 {
            background-position: -4px -141px;
        }
        .tx-mergecells-menu li.tx-menu-list-item a.tx-mergecells-2 {
            background-position: -4px -162px;
        }
        .tx-deletecells-menu {
            width: 74px;
        }
        .tx-deletecells-menu li.tx-menu-list-item a {
            background-image: url(/editor/images/icon/editor/skin/05/icon_table_layer01.gif);
            background-repeat: no-repeat;
            height: 17px;
            text-indent: 20px;
            width: 61px;
            display: block;
            border: 0 none #fff;
        }
        .tx-deletecells-menu li.tx-menu-list-item a.tx-item-hovered {
            color: #333;
            border: 2px solid #768fbd;
        }
        .tx-deletecells-menu li.tx-menu-list-item a.tx-deletecells-1 {
            background-position: -4px -117px;
        }
        .tx-deletecells-menu li.tx-menu-list-item a.tx-deletecells-2 {
            background-position: -5px -92px;
        }
        .tx-insertcells-menu {
            width: 98px;
        }
        .tx-insertcells-menu li.tx-menu-list-item a {
            background-image: url(/editor/images/icon/editor/skin/05/icon_table_layer01.gif);
            background-repeat: no-repeat;
            height: 17px;
            text-indent: 20px;
            width: 85px;
            display: block;
            border: 0 none #fff;
        }
        .tx-insertcells-menu li.tx-menu-list-item a.tx-item-hovered {
            color: #333;
            border: 2px solid #768fbd;
        }
        .tx-insertcells-menu li.tx-menu-list-item a.tx-insertcells-1 {
            background-position: -4px -5px;
        }
        .tx-insertcells-menu li.tx-menu-list-item a.tx-insertcells-2 {
            background-position: -4px -27px;
        }
        .tx-insertcells-menu li.tx-menu-list-item a.tx-insertcells-3 {
            background-position: -4px -50px;
        }
        .tx-insertcells-menu li.tx-menu-list-item a.tx-insertcells-4 {
            background-position: -4px -72px;
        }
        .tx-tabletemplate-menu {
            width: 348px;
            left: -250px;
        }
        .tx-tabletemplate-menu td.tx-menu-list-item a span {
            background-image: url(/editor/images/icon/editor/table/icon_form.gif);
            background-repeat: no-repeat;
            height: 31px;
            text-indent: -9999em;
            width: 29px;
            display: block;
            margin: 2px;
        }
        .tx-tabletemplate-menu td.tx-menu-list-item a span.tx-item-hovered {
            color: #333;
            margin: 0;
            border: 2px solid #768fbd;
        }
        .tx-tabletemplate-menu td.tx-menu-list-item a span.tx-tabletemplate-1 {
            background-position: -8px -7px;
        }
        .tx-tabletemplate-menu td.tx-menu-list-item a span.tx-tabletemplate-2 {
            background-position: -48px -7px;
        }
        .tx-tabletemplate-menu td.tx-menu-list-item a span.tx-tabletemplate-3 {
            background-position: -88px -7px;
        }
        .tx-tabletemplate-menu td.tx-menu-list-item a span.tx-tabletemplate-4 {
            background-position: -128px -7px;
        }
        .tx-tabletemplate-menu td.tx-menu-list-item span.tx-tabletemplate-5 {
            background-position: -168px -7px;
        }
        .tx-tabletemplate-menu td.tx-menu-list-item span.tx-tabletemplate-6 {
            background-position: -209px -7px;
        }
        .tx-tabletemplate-menu td.tx-menu-list-item span.tx-tabletemplate-7 {
            background-position: -249px -7px;
        }
        .tx-tabletemplate-menu td.tx-menu-list-item span.tx-tabletemplate-8 {
            background-position: -289px -7px;
        }
        .tx-tabletemplate-menu td.tx-menu-list-item span.tx-tabletemplate-9 {
            background-position: -329px -7px;
        }
        .tx-tabletemplate-menu td.tx-menu-list-item a span.tx-tabletemplate-10 {
            background-position: -8px -49px;
        }
        .tx-tabletemplate-menu td.tx-menu-list-item a span.tx-tabletemplate-11 {
            background-position: -48px -49px;
        }
        .tx-tabletemplate-menu td.tx-menu-list-item a span.tx-tabletemplate-12 {
            background-position: -88px -49px;
        }
        .tx-tabletemplate-menu td.tx-menu-list-item a span.tx-tabletemplate-13 {
            background-position: -128px -49px;
        }
        .tx-tabletemplate-menu td.tx-menu-list-item span.tx-tabletemplate-14 {
            background-position: -168px -49px;
        }
        .tx-tabletemplate-menu td.tx-menu-list-item span.tx-tabletemplate-15 {
            background-position: -209px -49px;
        }
        .tx-tabletemplate-menu td.tx-menu-list-item span.tx-tabletemplate-16 {
            background-position: -249px -49px;
        }
        .tx-tabletemplate-menu td.tx-menu-list-item span.tx-tabletemplate-17 {
            background-position: -289px -49px;
        }
        .tx-tabletemplate-menu td.tx-menu-list-item span.tx-tabletemplate-18 {
            background-position: -329px -49px;
        }
        .tx-tabletemplate-menu td.tx-menu-list-item a span.tx-tabletemplate-19 {
            background-position: -8px -91px;
        }
        .tx-tabletemplate-menu td.tx-menu-list-item a span.tx-tabletemplate-20 {
            background-position: -48px -91px;
        }
        .tx-tabletemplate-menu td.tx-menu-list-item a span.tx-tabletemplate-21 {
            background-position: -88px -91px;
        }
        .tx-tabletemplate-menu td.tx-menu-list-item a span.tx-tabletemplate-22 {
            background-position: -128px -91px;
        }
        .tx-tabletemplate-menu td.tx-menu-list-item span.tx-tabletemplate-23 {
            background-position: -169px -91px;
        }
        .tx-tabletemplate-menu td.tx-menu-list-item span.tx-tabletemplate-24 {
            background-position: -209px -91px;
        }
        .tx-tabletemplate-menu td.tx-menu-list-item span.tx-tabletemplate-25 {
            background-position: -249px -91px;
        }
        .tx-tabletemplate-menu td.tx-menu-list-item span.tx-tabletemplate-26 {
            background-position: -289px -91px;
        }
        .tx-tabletemplate-menu td.tx-menu-list-item span.tx-tabletemplate-27 {
            background-position: -329px -91px;
        }
        .tx-tabletemplate-menu td.tx-menu-list-item a span.tx-tabletemplate-28 {
            background-position: -8px -133px;
        }
        .tx-tabletemplate-menu td.tx-menu-list-item a span.tx-tabletemplate-29 {
            background-position: -48px -133px;
        }
        .tx-tabletemplate-menu td.tx-menu-list-item a span.tx-tabletemplate-30 {
            background-position: -88px -133px;
        }
        .tx-tabletemplate-menu td.tx-menu-list-item a span.tx-tabletemplate-31 {
            background-position: -128px -133px;
        }
        .tx-tabletemplate-menu td.tx-menu-list-item span.tx-tabletemplate-32 {
            background-position: -169px -133px;
        }
        .tx-tabletemplate-menu td.tx-menu-list-item span.tx-tabletemplate-33 {
            background-position: -209px -133px;
        }
        .tx-tabletemplate-menu td.tx-menu-list-item span.tx-tabletemplate-34 {
            background-position: -249px -133px;
        }
        .tx-tabletemplate-menu td.tx-menu-list-item span.tx-tabletemplate-35 {
            background-position: -289px -133px;
        }
        .tx-tabletemplate-menu td.tx-menu-list-item span.tx-tabletemplate-36 {
            background-position: -329px -133px;
        }
        .tx-tabletemplate-menu td.tx-menu-list-item a span.tx-tabletemplate-37 {
            background-position: -8px -175px;
        }
        .tx-tabletemplate-menu td.tx-menu-list-item a span.tx-tabletemplate-38 {
            background-position: -48px -175px;
        }
        .tx-tabletemplate-menu td.tx-menu-list-item a span.tx-tabletemplate-39 {
            background-position: -88px -175px;
        }
        .tx-tabletemplate-menu td.tx-menu-list-item a span.tx-tabletemplate-40 {
            background-position: -128px -175px;
        }
        .tx-tabletemplate-menu td.tx-menu-list-item span.tx-tabletemplate-41 {
            background-position: -169px -175px;
        }
        .tx-tabletemplate-menu td.tx-menu-list-item span.tx-tabletemplate-42 {
            background-position: -209px -175px;
        }
        .tx-tabletemplate-menu td.tx-menu-list-item span.tx-tabletemplate-43 {
            background-position: -249px -175px;
        }
        .tx-tabletemplate-menu td.tx-menu-list-item span.tx-tabletemplate-44 {
            background-position: -289px -175px;
        }
        .tx-tabletemplate-menu td.tx-menu-list-item span.tx-tabletemplate-45 {
            background-position: -329px -175px;
        }
        .tx-indent a.tx-icon {
            background-position: -63px -90px;
        }
        .tx-outdent a.tx-icon {
            background-position: -84px -90px;
        }
        .tx-undo a.tx-icon {
            background-position: -45px -70px;
        }
        .tx-redo a.tx-icon {
            background-position: -65px -70px;
        }
        .tx-table a.tx-icon {
            background-position: -84px -50px;
        }
        .tx-table-menu {
            width: 175px;
            color: #333;
            font-size: 11px;
            font-family: dotum, sans-serif;
            background-color: #fbfbfb;
        }
        .tx-table-menu a {
            overflow: hidden;
        }
        .tx-table-menu div.tx-menu-inner {
            padding: 6px;
            background-color: transparent;
        }
        .tx-table-menu .tx-more-button {
            float: right;
            margin: 8px 0 5px 0;
        }
        .tx-table-menu .tx-more-button a {
            display: block;
            width: 68px;
            height: 11px;
            text-indent: -10000px;
            background: url(/editor/images/icon/editor/table/btn_direct_setting.gif?v=2) no-repeat;
            padding: 0;
        }
        .tx-table-menu .tx-dynamic-sizer-context {
            position: relative;
            overflow: hidden;
            z-index: 100;
        }
        .tx-table-menu .tx-dynamic-sizer-display span {
            font-weight: bold;
            color: #7c84ef;
            font-family: dotum, sans-serif;
            font-size: 11px;
        }
        .tx-table-menu .tx-dynamic-sizer-context table {
            border-collapse: separate;
            border-spacing: 2px;
            padding: 0;
        }
        .tx-table-menu .tx-dynamic-sizer-context td div {
            width: 10px;
            height: 10px;
            cursor: default;
            font-size: 1px;
        }
        .tx-table-menu .tx-dynamic-sizer-context .tx-event td {
            padding: 2px;
            background-color: transparent;
            font-size: 1px;
            height: auto;
        }
        .tx-table-menu .tx-dynamic-sizer-context .tx-panel {
            position: absolute;
            left: 0;
            top: 0;
            z-index: -3;
        }
        .tx-table-menu .tx-dynamic-sizer-context .tx-panel td {
            border: 1px solid #d4d4d4;
            background-color: #fff;
            font-size: 1px;
            padding: 1px;
            height: auto;
        }
        .tx-table-menu .tx-dynamic-sizer-context div.tx-selection {
            overflow: hidden;
            position: absolute;
            width: 0;
            height: 0;
            left: 0;
            top: 0;
            z-index: -2;
        }
        .tx-table-menu .tx-dynamic-sizer-context .tx-selection td {
            border: 1px solid #b9c0ea;
            background-color: #c6c7f7;
            font-size: 1px;
            padding: 1px;
            height: auto;
        }
        .tx-content {
            border: 1px solid #acacac;
        }
        .tx-table-menu input {
            border: 1px solid #bababa;
            font-family: dotum, sans-serif;
            font-size: 11px;
            color: #333;
            width: 60px;
            height: 16px;
            padding: 0;
            margin-left: 15px;
        }
        .tx-table-menu .tx-table-input-area {
            border: 1px solid #e7e7e7;
            padding: 10px;
            margin-top: 5px;
        }
        .tx-table-menu .tx-menu-rowcol {
            clear: both;
        }
        .tx-table-menu .tx-field {
            position: relative;
            line-height: 1;
        }
        .tx-table-menu .tx-btn {
            height: 8px;
            margin: 0;
            padding: 0;
            overflow: hidden;
            text-indent: -1000em;
            width: 15px;
            z-index: 999;
            left: 102px;
            position: absolute;
        }
        .tx-table-menu .tx-btn-add {
            top: 1px;
            background: url(/editor/images/icon/editor/btn_plus.gif?v=2) no-repeat;
        }
        .tx-table-menu .tx-btn-sub {
            top: 9px;
            background: url(/editor/images/icon/editor/btn_minus.gif?v=2);
        }
        .tx-table-menu .tx-menu-enter div {
            margin-top: 4px;
        }
        .tx-table-menu .tx-btn-confirm {
            background: url(/editor/images/icon/editor/btn_confirm_s1.gif?v=2) no-repeat;
            width: 41px;
            height: 21px;
            text-indent: -1000em;
            float: left;
            margin-left: 35px;
        }
        .tx-table-menu .tx-btn-cancel {
            background: url(/editor/images/icon/editor/btn_cancel_s1.gif?v=2) no-repeat;
            width: 41px;
            height: 21px;
            text-indent: -1000em;
            float: left;
            margin-left: 3px;
        }
        .tx-table-btn-layer {
            position: absolute;
            display: none;
            width: 200px;
        }
        .tx-table-btn-layer a {
            float: left;
            position: relative;
            font-size: 0;
            line-height: 0;
            text-indent: -1000em;
            overflow: hidden;
            cursor: pointer;
            display: block;
        }
        a.tx-table-remove {
            width: 14px;
            height: 14px;
            margin: 3px 2px;
            background: url(/editor/images/icon/editor/btn_a_delete6.gif?v=2) no-repeat;
        }
        a.tx-table-edit-layout {
            width: 81px;
            height: 25px;
            background: url(/editor/images/icon/editor/table/btn_layout.gif) no-repeat;
        }
        a.tx-table-edit-template {
            width: 81px;
            height: 25px;
            background: url(/editor/images/icon/editor/table/btn_form.gif) no-repeat;
        }
        .tx-table-edit-container {
            background-color: #fbfbfb;
            border: 1px solid #fff;
            width: 409px;
            zoom: 1;
        }
        .tx-table-edit {
            width: 389px;
            margin: 10px;
            float: left;
            display: inline;
            position: relative;
        }
        .tx-table-edit a {
            overflow: hidden;
        }
        .tx-table-edit-container .tx-preview {
            width: 389px;
            margin: 10px 10px 0 10px;
            overflow: auto;
            height: 129px;
        }
        .tx-table-edit-container .tx-preview table {
            text-align: left;
            width: 389px;
            height: 129px;
        }
        .tx-table-edit-container .tx-preview td {
            width: auto;
            font-size: 4px;
            vertical-align: baseline;
            -moz-user-focus: ignore;
            -moz-user-input: disabled;
            -moz-user-select: none;
            -khtml-user-select: none;
            -o-user-select: none;
        }
        .tx-table-edit .tx-table-edit-selecttoggle {
            display: none;
        }
        .tx-table-edit .tx-table-edit-selecttoggle li {
            position: absolute;
            display: block;
        }
        .tx-table-edit .tx-table-edit-allselect {
            top: 4px;
            left: 243px;
        }
        .tx-table-edit .tx-table-edit-alldeselect {
            top: 4px;
            left: 323px;
        }
        .tx-table-edit .tx-table-edit-selecttoggle a {
            display: block;
            width: 65px;
            height: 13px;
            text-indent: -1000em;
        }
        .tx-table-edit .tx-table-edit-selecttoggle .tx-table-edit-allselect a {
            background-image: url(/editor/images/icon/editor/table/btn_tselect.gif);
        }
        .tx-table-edit .tx-table-edit-selecttoggle .tx-table-edit-alldeselect a {
            background-image: url(/editor/images/icon/editor/table/btn_tcancel.gif);
        }
        .tx-table-edit .tx-tab {
            float: left;
            margin-bottom: -2px;
            position: relative;
        }
        .tx-table-edit .tx-tab li {
            float: left;
            margin-top: 3px;
        }
        .tx-table-edit .tx-tab li a {
            display: block;
            width: 61px;
            height: 22px;
            text-indent: -1000em;
        }
        .tx-table-edit ul.tx-tab-menu1 {
            background: url(/editor/images/icon/editor/table/tab_01.gif) no-repeat;
        }
        .tx-table-edit ul.tx-tab-menu2 {
            background: url(/editor/images/icon/editor/table/tab_02.gif) no-repeat;
        }
        .tx-table-edit ul.tx-tab-menu3 {
            background: url(/editor/images/icon/editor/table/tab_03.gif) no-repeat;
        }
        .tx-table-edit .tx-table-edit-layout {
            float: left;
            clear: both;
            background: url(/editor/images/icon/editor/table/box1_left.gif) no-repeat;
            height: 93px;
            width: 389px;
        }
        .tx-table-edit .tx-table-edit-layout .tx-table-edit-layout-wrapper {
            background: url(/editor/images/icon/editor/table/box1_right.gif) no-repeat scroll top right;
            padding: 0;
            margin: 0;
            height: 100%;
            width: 100%;
        }
        .tx-table-edit .tx-table-edit-layout-insert {
            width: 105px;
            margin-top: 15px;
            margin-left: 10px;
            _margin-left: 5px;
        }
        .tx-table-edit .tx-table-edit-layout-cell {
            width: 124px;
            margin-top: 15px;
        }
        .tx-table-edit .tx-table-edit-layout-align {
            width: 128px;
            margin-top: 15px;
            margin-left: 5px;
            _margin-left: 2px;
        }
        .tx-table-edit .tx-table-edit-layout li,
        .tx-table-edit .tx-table-edit-layout div {
            float: left;
        }
        .tx-table-edit .tx-table-edit-layout h4 {
            font-family: dotum, sans-serif;
            display: block;
            clear: both;
            float: left;
            width: auto;
            height: 34px !important;
            text-indent: 0 !important;
            color: #4d4d4d;
            font-size: 11px;
            font-weight: normal;
            margin: 0 !important;
            padding-left: 6px;
            background: url(/editor/images/icon/editor/ic_dot.gif) no-repeat scroll 0 5px;
        }
        .tx-table-edit .tx-table-edit-layout li a {
            width: 27px;
            height: 28px;
            display: block;
            text-indent: -1000em;
        }
        .tx-table-edit .tx-table-edit-layout .tx-2cell {
            background: url(/editor/images/icon/editor/table/img_layout_bg.gif) no-repeat -7px -7px;
        }
        .tx-table-edit .tx-table-edit-layout .tx-2cell-left {
            background: url(/editor/images/icon/editor/table/img_layout_bg.gif) no-repeat -67px -7px;
        }
        .tx-table-edit .tx-table-edit-layout .tx-2cell-right {
            background: url(/editor/images/icon/editor/table/img_layout_bg.gif) no-repeat -127px -7px;
        }
        .tx-table-edit .tx-table-edit-layout .tx-3cell {
            background: url(/editor/images/icon/editor/table/img_layout_bg.gif) no-repeat -458px -7px;
        }
        .tx-table-edit .tx-table-edit-layout .tx-3cell-left {
            background: url(/editor/images/icon/editor/table/img_layout_bg.gif) no-repeat -200px -7px;
        }
        .tx-table-edit .tx-table-edit-layout .tx-3cell-right {
            background: url(/editor/images/icon/editor/table/img_layout_bg.gif) no-repeat -372px -7px;
        }
        .tx-table-edit .tx-table-edit-layout .tx-3cell-center {
            background: url(/editor/images/icon/editor/table/img_layout_bg.gif) no-repeat -286px -7px;
        }
        .tx-table-edit .tx-table-edit-layout li a {
            background: url(/editor/images/icon/editor/table/icon_layout_hovered.gif) no-repeat;
        }
        .tx-table-edit .tx-table-edit-layout li a.tx-up {
            background-position: -3px -3px;
        }
        .tx-table-edit .tx-table-edit-layout li a.tx-down {
            background-position: -30px -3px;
        }
        .tx-table-edit .tx-table-edit-layout li a.tx-left {
            background-position: -3px -30px;
        }
        .tx-table-edit .tx-table-edit-layout li a.tx-right {
            background-position: -30px -30px;
        }
        .tx-table-edit .tx-table-edit-layout li a.tx-col {
            background-position: -55px -3px;
        }
        .tx-table-edit .tx-table-edit-layout li a.tx-row {
            background-position: -82px -3px;
        }
        .tx-table-edit .tx-table-edit-layout li a.tx-merge {
            background-position: -55px -30px;
        }
        .tx-table-edit .tx-table-edit-layout li a.tx-split {
            background-position: -81px -30px;
        }
        .tx-table-edit .tx-table-edit-layout li a.tx-top {
            background-position: -119px -3px;
        }
        .tx-table-edit .tx-table-edit-layout li a.tx-middle {
            background-position: -146px -3px;
        }
        .tx-table-edit .tx-table-edit-layout li a.tx-bottom {
            background-position: -173px -3px;
        }
        .tx-table-edit .tx-table-edit-layout li a.tx-alignleft {
            background-position: -119px -30px;
        }
        .tx-table-edit .tx-table-edit-layout li a.tx-aligncenter {
            background-position: -146px -30px;
        }
        .tx-table-edit .tx-table-edit-layout li a.tx-alignright {
            background-position: -173px -30px;
        }
        .tx-table-edit .tx-table-edit-layout-insert ul {
            float: left;
            display: inline;
            margin-bottom: 5px;
            margin-left: 10px;
        }
        .tx-table-edit .tx-table-edit-layout-cell ul {
            float: right;
            margin-bottom: 5px;
            margin-right: 8px;
            _margin-right: 6px;
        }
        .tx-table-edit .tx-table-edit-layout-align ul {
            margin-bottom: 5px;
            margin-left: 10px;
            float: left;
        }
        .tx-table-edit .tx-table-edit-design {
            width: 389px;
            float: left;
            clear: both;
            background: url(/editor/images/icon/editor/table/box2_left.gif) no-repeat;
            height: 55px;
            font-size: 11px;
            font-family: dotum, sans-serif;
            padding: 0;
        }
        .tx-table-edit .tx-table-edit-design .tx-table-edit-design-wrapper {
            background: url(/editor/images/icon/editor/table/box2_right.gif) no-repeat top right;
            height: 100%;
            width: 100%;
        }
        .tx-table-edit .tx-table-edit-design dl {
            clear: both;
            float: left;
            margin: 16px 0;
        }
        .tx-table-edit .tx-table-edit-design dt {
            margin-right: 8px;
            margin-top: 4px;
            margin-left: 12px;
            display: inline;
            color: #4d4d4d;
            font-size: 11px;
            font-family: dotum, sans-serif;
            padding-left: 6px;
            background: url(/editor/images/icon/editor/ic_dot.gif) no-repeat scroll 0 5px;
        }
        .tx-table-edit .tx-table-edit-design dt,
        .tx-table-edit .tx-table-edit-design dd {
            float: left;
        }
        .tx-table-edit .tx-table-edit-design .tx-table-edit-bordercolor,
        .tx-table-edit .tx-table-edit-design .tx-table-edit-borderwidth {
            margin-right: 6px;
        }
        .tx-table-edit .tx-table-edit-design dd {
            position: relative;
            background: url(/editor/images/icon/editor/table/img_des_bg.gif) no-repeat;
        }
        .tx-table-edit dd.tx-btn-widget {
            background-position: -51px -8px;
        }
        .tx-table-edit dd.tx-btn-widget-hovered,
        .tx-table-edit dd.tx-btn-widget-pushed {
            background-position: -7px -8px;
        }
        .tx-table-edit dd.tx-btn-widget-tbg {
            background-position: -51px -39px;
        }
        .tx-table-edit dd.tx-btn-widget-tbg-hovered,
        .tx-table-edit dd.tx-btn-widget-tbg-pushed {
            background-position: -7px -39px;
        }
        .tx-table-edit dd.tx-btn-widget-brbg {
            background-position: -51px -70px;
        }
        .tx-table-edit dd.tx-btn-widget-brbg-hovered,
        .tx-table-edit dd.tx-btn-widget-brbg-pushed {
            background-position: -7px -70px;
        }
        .tx-table-edit .tx-table-edit-design a.tx-icon {
            text-indent: -1000em;
            background: url(/editor/images/icon/editor/table/icon_design.gif) no-repeat;
            width: 25px;
            height: 23px;
            display: block;
            float: left;
            font-size: 1px;
        }
        .tx-table-edit .tx-table-edit-design a.tx-arrow {
            text-indent: -1000em;
            width: 12px;
            height: 23px;
            display: block;
        }
        .tx-table-edit .tx-table-edit-design .tx-table-edit-borderrange .tx-icon {
            background: url(/editor/images/icon/editor/table/button_line.gif) no-repeat 0 -1px;
        }
        .tx-table-edit .tx-table-edit-design .tx-table-edit-borderrange .tx-icon.tx-range-all {
            background-position: 0 -1px;
        }
        .tx-table-edit .tx-table-edit-design .tx-table-edit-borderrange .tx-icon.tx-range-out {
            background-position: -21px -1px;
        }
        .tx-table-edit .tx-table-edit-design .tx-table-edit-borderrange .tx-icon.tx-range-in {
            background-position: -42px -1px;
        }
        .tx-table-edit .tx-table-edit-design .tx-table-edit-borderrange .tx-icon.tx-range-top {
            background-position: -63px -1px;
        }
        .tx-table-edit .tx-table-edit-design .tx-table-edit-borderrange .tx-icon.tx-range-bottom {
            background-position: -84px -1px;
        }
        .tx-table-edit .tx-table-edit-design .tx-table-edit-borderrange .tx-icon.tx-range-left {
            background-position: -105px -1px;
        }
        .tx-table-edit .tx-table-edit-design .tx-table-edit-borderrange .tx-icon.tx-range-right {
            background-position: -126px -1px;
        }
        .tx-table-edit .tx-table-edit-design .tx-table-edit-bordercolor .tx-icon {
            background-position: -29px -2px;
        }
        .tx-table-edit .tx-table-edit-design .tx-table-edit-bordercolor a.tx-selected {
            background-position: -143px -2px;
        }
        .tx-table-edit .tx-table-edit-design .tx-table-edit-borderwidth .tx-icon {
            background-position: -61px -2px;
        }
        .tx-table-edit .tx-table-edit-design .tx-table-edit-borderstyle .tx-icon {
            background-position: -87px -2px;
        }
        .tx-table-edit .tx-table-edit-design .tx-table-edit-backcolor .tx-icon {
            background-position: -115px -2px;
        }
        .tx-table-edit .tx-table-edit-design .tx-table-edit-backcolor a.tx-selected {
            background-image: none;
        }
        .tx-table-edit .tx-table-edit-design .tx-table-edit-backcolor .tx-colorpallete {
            left: -160px;
        }
        .tx-table-edit .tx-colorpallete,
        .tx-table-edit .tx-menu {
            top: 22px;
            left: 0;
        }
        .tx-table-edit .tx-table-edit-design .tx-table-edit-borderrange .tx-menu {
            width: 108px;
            color: #595959;
            font-family: dotum, sans-serif;
            font-size: 11px;
        }
        .tx-table-edit .tx-table-edit-design .tx-table-edit-borderrange .tx-menu .tx-menu-list {
            margin-top: 5px;
        }
        .tx-table-edit .tx-table-edit-design .tx-table-edit-borderrange .tx-menu li {
            margin-bottom: 6px;
        }
        .tx-table-edit .tx-table-edit-design .tx-table-edit-borderrange .tx-menu a {
            display: block;
            margin-left: 3px;
            background: url(/editor/images/icon/editor/table/menu_line.gif) no-repeat;
            padding: 1px 0 1px 25px;
        }
        .tx-table-edit .tx-table-edit-design .tx-table-edit-borderrange .tx-menu a.tx-all {
            background-position: -1px -3px;
        }
        .tx-table-edit .tx-table-edit-design .tx-table-edit-borderrange .tx-menu a.tx-out {
            background-position: -1px -19px;
        }
        .tx-table-edit .tx-table-edit-design .tx-table-edit-borderrange .tx-menu a.tx-in {
            background-position: -1px -35px;
        }
        .tx-table-edit .tx-table-edit-design .tx-table-edit-borderrange .tx-menu a.tx-top {
            background-position: -1px -51px;
        }
        .tx-table-edit .tx-table-edit-design .tx-table-edit-borderrange .tx-menu a.tx-bottom {
            background-position: -1px -67px;
        }
        .tx-table-edit .tx-table-edit-design .tx-table-edit-borderrange .tx-menu a.tx-left {
            background-position: -1px -83px;
        }
        .tx-table-edit .tx-table-edit-design .tx-table-edit-borderrange .tx-menu a.tx-right {
            background-position: -1px -98px;
        }
        .tx-table-edit .tx-table-edit-design .tx-table-edit-borderwidth .tx-menu {
            width: 108px;
        }
        .tx-table-edit .tx-table-edit-design .tx-table-edit-borderwidth .tx-menu a {
            display: block;
            height: 17px;
            width: 100px;
            margin-left: 3px;
            background: url(/editor/images/icon/editor/menu_border_width.gif) no-repeat;
            text-indent: -1000em;
        }
        .tx-table-edit .tx-table-edit-design .tx-table-edit-borderwidth .tx-menu a.tx-1px {
            background-position: -1px 3px;
        }
        .tx-table-edit .tx-table-edit-design .tx-table-edit-borderwidth .tx-menu a.tx-2px {
            background-position: -1px -20px;
        }
        .tx-table-edit .tx-table-edit-design .tx-table-edit-borderwidth .tx-menu a.tx-3px {
            background-position: -1px -41px;
        }
        .tx-table-edit .tx-table-edit-design .tx-table-edit-borderwidth .tx-menu a.tx-4px {
            background-position: -1px -61px;
        }
        .tx-table-edit .tx-table-edit-design .tx-table-edit-borderwidth .tx-menu a.tx-5px {
            background-position: -1px -81px;
        }
        .tx-table-edit .tx-table-edit-design .tx-table-edit-borderwidth .tx-menu a.tx-6px {
            background-position: -1px -101px;
        }
        .tx-table-edit .tx-table-edit-design .tx-table-edit-borderwidth .tx-menu a.tx-7px {
            background-position: -1px -121px;
        }
        .tx-table-edit .tx-table-edit-design .tx-table-edit-borderstyle .tx-menu {
            width: 108px;
        }
        .tx-table-edit .tx-table-edit-design .tx-table-edit-borderstyle .tx-menu a {
            display: block;
            margin-left: 5px;
            height: 17px;
            width: 100px;
            background: url(/editor/images/icon/editor/menu_border_style.gif) no-repeat;
            text-indent: -1000em;
        }
        .tx-table-edit .tx-table-edit-design .tx-table-edit-borderstyle .tx-menu a.tx-solid {
            background-position: -1px -16px;
        }
        .tx-table-edit .tx-table-edit-design .tx-table-edit-borderstyle .tx-menu a.tx-dashed {
            background-position: -1px -58px;
        }
        .tx-table-edit .tx-table-edit-design .tx-table-edit-borderstyle .tx-menu a.tx-dotted {
            background-position: -1px -39px;
        }
        .tx-table-edit .tx-table-edit-design .tx-table-edit-borderstyle .tx-menu a.tx-none {
            background-position: -1px 3px;
        }
        .tx-table-edit .tx-table-edit-template {
            width: 389px;
            float: left;
            clear: both;
            background: url(/editor/images/icon/editor/table/box2_left.gif) no-repeat;
            padding: 0;
            margin: 0;
        }
        .tx-table-edit .tx-table-edit-template .tx-table-edit-template-wrapper {
            background: url(/editor/images/icon/editor/table/box2_right.gif) no-repeat top right;
            padding: 0;
            height: 100%;
            width: 100%;
            float: left;
        }
        .tx-table-edit .tx-table-edit-template ul {
            margin: 8px 0 5px 0;
            padding: 0;
            float: left;
        }
        .tx-table-edit .tx-table-edit-template a.tx-button {
            background: url(/editor/images/icon/editor/table/btn_down.gif) no-repeat;
            width: 13px;
            height: 39px;
            display: block;
            text-indent: -1000em;
            margin: 17px 0 0 9px;
            float: left;
        }
        .tx-table-edit .tx-table-edit-template a.tx-button-on {
            background: url(/editor/images/icon/editor/table/btn_up.gif) no-repeat;
            width: 13px;
            height: 38px;
            display: block;
            text-indent: -1000em;
            margin: 17px 0 0 9px;
            float: left;
        }
        .tx-table-edit .tx-table-edit-template li {
            padding: 0;
            float: left;
            display: inline;
            background-repeat: no-repeat;
            margin-left: 10px;
            margin-top: 7px;
            background-image: url(/editor/images/icon/editor/table/icon_form.gif);
            width: 30px;
            height: 32px;
        }
        .tx-table-edit .tx-table-edit-template .tx-table-edit-template-all {
            margin-top: 0;
            border: 1px solid #d5d5d5;
            border-top: none;
            background-color: #fbfbfb;
            padding-bottom: 5px;
            width: 387px;
        }
        .tx-table-edit .tx-table-edit-template li a {
            display: block;
            width: 30px;
            height: 32px;
        }
        .tx-table-edit .tx-table-edit-template li a:hover {
            width: 26px;
            height: 28px;
            border: 2px solid #7c84ef;
        }
        .tx-table-edit-template .tx-ex1 {
            background-position: -8px -7px;
        }
        .tx-table-edit-template .tx-ex2 {
            background-position: -48px -7px;
        }
        .tx-table-edit-template .tx-ex3 {
            background-position: -88px -7px;
        }
        .tx-table-edit-template .tx-ex4 {
            background-position: -128px -7px;
        }
        .tx-table-edit-template .tx-ex5 {
            background-position: -168px -7px;
        }
        .tx-table-edit-template .tx-ex6 {
            background-position: -209px -7px;
        }
        .tx-table-edit-template .tx-ex7 {
            background-position: -249px -7px;
        }
        .tx-table-edit-template .tx-ex8 {
            background-position: -289px -7px;
        }
        .tx-table-edit-template .tx-ex9 {
            background-position: -329px -7px;
        }
        .tx-table-edit-template .tx-ex11 {
            background-position: -8px -49px;
        }
        .tx-table-edit-template .tx-ex12 {
            background-position: -48px -49px;
        }
        .tx-table-edit-template .tx-ex13 {
            background-position: -88px -49px;
        }
        .tx-table-edit-template .tx-ex14 {
            background-position: -128px -49px;
        }
        .tx-table-edit-template .tx-ex15 {
            background-position: -168px -49px;
        }
        .tx-table-edit-template .tx-ex16 {
            background-position: -209px -49px;
        }
        .tx-table-edit-template .tx-ex17 {
            background-position: -249px -49px;
        }
        .tx-table-edit-template .tx-ex18 {
            background-position: -289px -49px;
        }
        .tx-table-edit-template .tx-ex19 {
            background-position: -329px -49px;
        }
        .tx-table-edit-template .tx-ex21 {
            background-position: -8px -91px;
        }
        .tx-table-edit-template .tx-ex22 {
            background-position: -48px -91px;
        }
        .tx-table-edit-template .tx-ex23 {
            background-position: -88px -91px;
        }
        .tx-table-edit-template .tx-ex24 {
            background-position: -128px -91px;
        }
        .tx-table-edit-template .tx-ex25 {
            background-position: -168px -91px;
        }
        .tx-table-edit-template .tx-ex26 {
            background-position: -209px -91px;
        }
        .tx-table-edit-template .tx-ex27 {
            background-position: -249px -91px;
        }
        .tx-table-edit-template .tx-ex28 {
            background-position: -289px -91px;
        }
        .tx-table-edit-template .tx-ex29 {
            background-position: -329px -91px;
        }
        .tx-table-edit-template .tx-ex31 {
            background-position: -8px -133px;
        }
        .tx-table-edit-template .tx-ex32 {
            background-position: -48px -133px;
        }
        .tx-table-edit-template .tx-ex33 {
            background-position: -88px -133px;
        }
        .tx-table-edit-template .tx-ex34 {
            background-position: -128px -133px;
        }
        .tx-table-edit-template .tx-ex35 {
            background-position: -168px -133px;
        }
        .tx-table-edit-template .tx-ex36 {
            background-position: -209px -133px;
        }
        .tx-table-edit-template .tx-ex37 {
            background-position: -249px -133px;
        }
        .tx-table-edit-template .tx-ex38 {
            background-position: -289px -133px;
        }
        .tx-table-edit-template .tx-ex39 {
            background-position: -329px -133px;
        }
        .tx-table-edit-template .tx-ex41 {
            background-position: -8px -175px;
        }
        .tx-table-edit-template .tx-ex42 {
            background-position: -48px -175px;
        }
        .tx-table-edit-template .tx-ex43 {
            background-position: -88px -175px;
        }
        .tx-table-edit-template .tx-ex44 {
            background-position: -128px -175px;
        }
        .tx-table-edit-template .tx-ex45 {
            background-position: -168px -175px;
        }
        .tx-table-edit-template .tx-ex46 {
            background-position: -209px -175px;
        }
        .tx-table-edit-template .tx-ex47 {
            background-position: -249px -175px;
        }
        .tx-table-edit-template .tx-ex48 {
            background-position: -289px -175px;
        }
        .tx-table-edit-template .tx-ex49 {
            background-position: -329px -175px;
        }
        .tx-table-edit .tx-table-edit-main {
            margin-top: 5px;
            clear: both;
            float: left;
            width: 90px;
            margin-left: 160px;
            display: inline;
        }
        .tx-table-edit .tx-table-edit-main a {
            display: block;
            float: left;
            width: 41px;
            height: 21px;
            margin-right: 3px;
            text-indent: -1000em;
        }
        .tx-table-edit .tx-table-edit-main .tx-confirm {
            background: url(/editor/images/icon/editor/btn_confirm_s1.gif?v=2) no-repeat;
        }
        .tx-table-edit .tx-table-edit-main .tx-cancel {
            background: url(/editor/images/icon/editor/btn_cancel_s1.gif?v=2) no-repeat;
        }
        *:first-child + html .tx-table-edit .tx-table-edit-layout ul {
            margin-right: 9px;
        }
        .tx-tabletemplate a.tx-icon {
            background-position: -125px -50px;
        }
        .tx-tabletemplate-menu div.tx-menu-inner {
            padding: 7px;
            background: #f9f9f9;
        }
        .tx-tabletemplate-menu ul.tx-menu-matrix-title {
            width: 196px;
        }
        .tx-tabletemplate-menu div.tx-menu-matrix-list {
            display: none;
            margin-top: 6px;
            background: #fff;
            width: 196px;
        }
        .tx-tabletemplate-menu div.tx-menu-matrix-list table {
            border-collapse: collapse;
        }
        .tx-tabletemplate-menu div.tx-menu-matrix-list td {
            padding: 0;
            border: 1px solid #e5e5e5;
            height: 24px;
        }
        .tx-tabletemplate-menu div.tx-menu-matrix-list td a {
            float: left;
            border: 2px solid #fff;
        }
        .tx-tabletemplate-menu div.tx-menu-matrix-list td a:hover {
            border: 2px solid #768fbd;
        }
        .tx-tabletemplate-menu div.tx-menu-matrix-list td span {
            display: block;
            width: 23px;
            height: 23px;
            text-align: center;
            color: #333;
            cursor: pointer;
            overflow: hidden;
            text-indent: -100em;
        }
        .tx-emoticon a.tx-icon {
            background-position: -125px -50px;
        }
        .tx-emoticon-menu div.tx-menu-inner {
            padding: 7px;
            background: #f9f9f9;
        }
        .tx-emoticon-menu ul.tx-menu-matrix-title {
            width: 196px;
        }
        .tx-emoticon-menu div.tx-menu-matrix-list {
            display: none;
            margin-top: 6px;
            background: #fff;
            width: 196px;
        }
        .tx-emoticon-menu div.tx-menu-matrix-list table {
            border-collapse: collapse;
        }
        .tx-emoticon-menu div.tx-menu-matrix-list td {
            padding: 0;
            border: 1px solid #e5e5e5;
            height: 24px;
        }
        .tx-emoticon-menu div.tx-menu-matrix-list td a {
            float: left;
            border: 2px solid #fff;
        }
        .tx-emoticon-menu div.tx-menu-matrix-list td a:hover {
            border: 2px solid #768fbd;
        }
        .tx-emoticon-menu div.tx-menu-matrix-list td span {
            display: block;
            width: 23px;
            height: 23px;
            text-align: center;
            color: #333;
            cursor: pointer;
            overflow: hidden;
            text-indent: -100em;
        }
        .tx-emoticon-menu div.tx-menu-matrix-per table {
            background: url(/editor/images/icon/editor/emoticon/emoticon_01.gif?v=2) no-repeat;
        }
        .tx-emoticon-menu div.tx-menu-matrix-ani table {
            background: url(/editor/images/icon/editor/emoticon/emoticon_02.gif?v=2) no-repeat;
        }
        .tx-emoticon-menu div.tx-menu-matrix-things table {
            background: url(/editor/images/icon/editor/emoticon/emoticon_03.gif?v=2) no-repeat;
        }
        .tx-emoticon-menu div.tx-menu-matrix-etc table {
            background: url(/editor/images/icon/editor/emoticon/emoticon_04.gif?v=2) no-repeat;
        }
        .tx-dictionary a.tx-icon {
            background-position: -104px -69px;
        }
        .tx-quote a.tx-icon {
            background-position: -125px -90px;
        }
        .tx-quote-menu {
            width: 149px;
        }
        .tx-quote-menu div.tx-menu-list {
            padding: 4px;
        }
        .tx-quote-menu div.tx-menu-list table {
            border-collapse: collapse;
        }
        .tx-quote-menu div.tx-menu-list td {
            padding: 0;
            border: 1px solid #f9f9f9;
        }
        .tx-quote-menu div.tx-menu-list td a {
            float: left;
            border: 2px solid #f9f9f9;
        }
        .tx-quote-menu div.tx-menu-list td a:hover {
            border: 2px solid #768fbd;
        }
        .tx-quote-menu div.tx-menu-list td span {
            display: block;
            cursor: pointer;
        }
        .tx-quote-menu div.tx-menu-list td span img {
            width: 42px;
            height: 42px;
        }
        .tx-lineheight a.tx-icon {
            width: 21px;
        }
        .tx-lineheight a.tx-icon {
            background-position: -44px -90px;
        }
        .tx-insertcells a.tx-icon2 {
            width: 21px;
        }
        .tx-insertcells a.tx-icon2 {
            background-position: -6px -26px;
        }
        .tx-deletecells a.tx-icon2 {
            width: 21px;
        }
        .tx-deletecells a.tx-icon2 {
            background-position: -7px -48px;
        }
        .tx-mergecells a.tx-icon2 {
            width: 21px;
        }
        .tx-mergecells a.tx-icon2 {
            background-position: -6px -72px;
        }
        .tx-splitcells a.tx-icon2 {
            width: 21px;
        }
        .tx-splitcells a.tx-icon2 {
            background-position: -6px -34px;
        }
        .tx-cellsoutline a.tx-icon2 {
            width: 21px;
        }
        .tx-cellsoutline a.tx-icon2 {
            background-position: -5px -94px;
        }
        .tx-cellslinecolor a.tx-icon2 {
            width: 22px;
        }
        .tx-cellslinecolor a.tx-icon2 {
            background-position: -6px -115px;
        }
        .tx-cellslinestyle a.tx-icon2 {
            width: 21px;
        }
        .tx-cellslinestyle a.tx-icon2 {
            background-position: -5px -153px;
        }
        .tx-cellslineheight a.tx-icon2 {
            width: 21px;
        }
        .tx-cellslineheight a.tx-icon2 {
            background-position: -5px -135px;
        }
        .tx-tableedit-title {
            background: url(/editor/images/icon/editor/skin/05/icon_add_table01.gif);
            background-position: 40px 215px;
            width: 38px;
            height: 20px;
        }
        .tx-cellslinepreview a:hover {
            text-decoration: none;
        }
        .tx-cellslinepreview span {
            line-height: 1.5;
        }
        .tx-cellslinepreview-menu {
            width: 84px;
        }
        .tx-tablebackcolor a.tx-icon2 {
            width: 22px;
            height: 21px;
        }
        .tx-tablebackcolor a.tx-icon2 {
            background-position: -5px -193px;
        }
        .tx-tablebackcolor-menu {
            left: -165px;
        }
        .tx-tabletemplate a.tx-icon2 {
            width: 22px;
        }
        .tx-tabletemplate a.tx-icon2 {
            background-position: -5px -173px;
        }
        .tx-horizontalrule a.tx-icon {
            background-position: -23px -90px;
        }
        .tx-horizontalrule-menu table {
            border-collapse: collapse;
            background: #fff;
        }
        .tx-horizontalrule-menu td {
            padding: 0;
            height: auto;
        }
        .tx-horizontalrule-menu td a:hover {
            background-color: #c6cffe;
        }
        .tx-horizontalrule-menu td span {
            display: block;
            cursor: pointer;
        }
        .tx-horizontalrule-menu td span img {
            width: 150px;
            height: 24px;
        }
        .tx-textbox a.tx-icon {
            background-position: -44px -110px;
        }
        .tx-textbox-menu {
            width: 161px;
        }
        .tx-textbox-menu div.tx-menu-inner {
            padding: 5px;
            background: #f9f9f9;
        }
        .tx-textbox-menu div.tx-menu-list table {
            border-collapse: collapse;
            background-image: url(/editor/images/icon/editor/textbox/textbox.gif?v=2);
            background-repeat: no-repeat;
            background-position: -2px -2px;
        }
        * + html .tx-textbox-menu div.tx-menu-list table {
            background-position: -1px -1px;
        }
        * html .tx-textbox-menu div.tx-menu-list table {
            background-position: -1px -1px;
        }
        .tx-textbox-menu div.tx-menu-list td {
            padding: 0;
            border: 1px solid #f9f9f9;
            height: auto;
        }
        .tx-textbox-menu div.tx-menu-list td a {
            float: left;
            border: 1px solid #f9f9f9;
        }
        .tx-textbox-menu div.tx-menu-list td a:hover {
            border: 1px solid #768fbd;
        }
        .tx-textbox-menu div.tx-menu-list td span {
            display: block;
            width: 22px;
            height: 22px;
            text-align: center;
            color: #333;
            cursor: pointer;
            overflow: hidden;
            text-indent: -100em;
        }
        .tx-background a.tx-icon {
            background-position: -105px -50px;
        }
        .tx-list .tx-formula a {
            height: 25px;
            width: 38px;
            background-position: -519px 6px;
        }
        .tx-formula a:hover {
            background-position: -519px -18px;
        }
        .tx-fullscreen {
            margin-top: -1px;
            margin-right: -2px;
            background-position: -331px -97px;
        }
        .tx-fullscreen a.tx-icon {
            width: 16px;
            height: 30px;
            background-image: none;
        }
        .tx-fullscreen-notice {
            display: none;
            background-color: #484848;
            border-bottom: 1px solid #262626;
            color: #ccc;
            font-family: dotum, verdana;
            font-size: 11px;
            height: 20px;
            min-width: 800px;
            padding: 10px 0 0 10px;
            white-space: nowrap;
        }
        .tx-editor-container .tx-fullscreen-notice a {
            background: transparent url(/editor/images/icon/editor/ic_arrow02.gif?v=2) no-repeat scroll right 2px;
            font-family: dotum, verdana;
            font-size: 11px;
            padding: 0 7px 0 5px;
            text-decoration: underline;
            color: #fff;
            font-weight: bold;
        }
        .tx-fullscreen-notice a:hover {
            color: #fff;
        }
        .tx-fullscreen-line {
            display: none;
            background: transparent url(/editor/images/icon/editor/w_bgimg_02.gif?v=2) repeat-x;
            height: 17px;
            font-size: 0;
        }
        .tx-fullscreen-line .tx-fullscreen-line-division {
            background: transparent url(/editor/images/icon/editor/skin/01/bot_bg.gif) repeat-x;
            height: 7px;
            overflow: hidden;
            text-indent: -100em;
        }
        .tx-fullscreen-line-division .tx-fullscreen-line-left {
            background: transparent url(/editor/images/icon/editor/skin/01/bot_left.gif) no-repeat left top;
            width: 7px;
            height: 7px;
            float: left;
            overflow: hidden;
            text-indent: -100em;
        }
        .tx-fullscreen-line-division .tx-fullscreen-line-right {
            background: transparent url(/editor/images/icon/editor/skin/01/bot_right.gif) no-repeat right top;
            width: 7px;
            height: 7px;
            float: right;
            overflow: hidden;
            text-indent: -100em;
        }
        .tx-fullscreen-line .tx-fullscreen-line-box {
            background: transparent url(/editor/images/icon/editor/w_bgimg.gif) repeat-x;
            height: 10px;
            overflow: hidden;
            text-indent: -100em;
            font-size: 0;
        }
        .tx-fullscreen-line-box .tx-fullscreen-line-left {
            background: transparent url(/editor/images/icon/editor/w_leftimg.gif) no-repeat left top;
            width: 4px;
            height: 10px;
            float: left;
            overflow: hidden;
            text-indent: -100em;
        }
        .tx-fullscreen-line-box .tx-fullscreen-line-right {
            background: transparent url(/editor/images/icon/editor/w_rightimg.gif) no-repeat right top;
            width: 4px;
            height: 10px;
            float: right;
            overflow: hidden;
            text-indent: -100em;
        }
        .tx-fullscreen-line-box a {
            display: block;
            width: 59px;
            height: 10px;
            margin: 0 auto;
            overflow: hidden;
            text-indent: -10000em;
            -moz-user-select: none;
            cursor: pointer;
            background: transparent url(/editor/images/icon/editor/skin/01/btn_spread_box.gif) no-repeat;
        }
        .tx-fullscreen-line-box a.tx-attach-close {
            background: transparent url(/editor/images/icon/editor/skin/01/btn_fold_box.gif?v=2) no-repeat;
        }
        .tx-editor-fullscreen {
            background-color: #fff;
            left: 0;
            min-width: 800px;
            position: absolute;
            top: 0;
            width: 100%;
            z-index: 999999;
        }
        .tx-editor-fullscreen .tx-fullscreen {
            background-position: -331px -132px;
        }
        .tx-editor-fullscreen .tx-fullscreen-notice {
            display: block;
        }
        .tx-editor-fullscreen .tx-fullscreen-line {
            display: block;
        }
        .tx-editor-fullscreen .tx-attach-div {
            margin-top: 0;
        }
        .tx-editor-fullscreen .tx-attach-txt {
            padding-left: 9px;
        }
        * html .tx-editor-fullscreen .tx-attach-txt {
            padding-top: 10px;
        }
        * + html .tx-editor-fullscreen .tx-attach-txt {
            padding-top: 10px;
        }
        * html .tx-editor-fullscreen div.tx-canvas textarea {
            width: 100%;
        }
        .tx-fullscreen_attachbox-bar {
            cursor: default;
            display: none;
        }
        .tx-fullscreen_attachbox-bar img {
            -moz-user-select: none;
            -khtml-user-select: none;
        }
        .tx-fullscreen_attachbox-bar div.tx-fullscreen_attachbox-bar-left {
            width: 100%;
            height: 7px;
            background: url(/editor/images/icon/editor/skin/01/bot_left.gif?v=2) no-repeat;
        }
        .tx-fullscreen_attachbox-bar div.tx-fullscreen_attachbox-bar-right {
            height: 7px;
            background: url(/editor/images/icon/editor/skin/01/bot_right.gif?v=2) no-repeat top right;
        }
        .tx-fullscreen_attachbox-bar div.tx-fullscreen_attachbox-bar-bg {
            height: 7px;
            margin: 0 7px;
            background: url(/editor/images/icon/editor/skin/01/bot_bg.gif?v=2) repeat-x;
            text-align: center;
        }
        .tx-fullscreen {
            _position: absolute;
            _right: 0;
        }
        .tx-sidebar-boundary .tx-nav-opt {
            _padding-right: 15px;
        }
        .tx-extra a.tx-icon {
            background-image: none;
            width: 13px;
            height: 30px;
        }
        .tx-list-extra .tx-extra {
            margin-top: -4px;
        }
        .tx-list-extra .tx-btn-nlrbg,
        .tx-list-extra .tx-btn-nlrbg-hovered {
            background-position: -293px -97px;
        }
        .tx-list-extra .tx-btn-nlrbg-pushed {
            background-position: -293px -132px;
        }
        ul.tx-extra-menu {
            padding: 0 8px;
            top: 25px;
            border: 1px solid #e0e0e0;
            width: 36px;
        }
        .tx-extra-menu li.tx-list {
            float: none;
            border-bottom: 1px solid #f1f1f1;
            margin: 0;
            padding: 0 4px;
            height: 25px;
        }
        .tx-extra-menu li.tx-list a {
            float: none;
        }
        .tx-toolbar-extra-drop-down .tx-disable a {
            cursor: default;
            filter: alpha(opacity=30);
            opacity: 0.3;
        }
        .tx-extra {
            _position: absolute;
            _right: 0;
        }
        .tx-editor-container .tx-nav-search .tx-list-extra {
            _padding-right: 15px;
        }
        .tx-advanced {
            margin-top: -7px;
            margin-right: -2px;
            background-position: -311px -95px;
        }
        .tx-advanced.tx-btn-nlrbg-pushed {
            background-position: -311px -131px;
            margin-top: -5px;
        }
        .tx-advanced a.tx-icon {
            width: 15px;
            height: 31px;
            background-image: none;
        }
        .tx-advanced.tx-btn-nlrbg-pushed a.tx-icon {
            height: 62px;
        }
        .tx-toolbar-basic-open .tx-advanced a.tx-icon {
            background-position: -126px -110px;
        }
        .tx-toolbar-advanced {
            border-top: 1px solid #e8e8e8;
        }
        .tx-toolbar-advanced li.tx-list {
            z-index: 4;
        }
        .tx-advanced {
            _position: absolute;
            _right: 0;
        }
        .tx-richtextbox a.tx-icon {
            background-position: -44px -110px;
        }
        .tx-richtextbox a.tx-icon {
            float: left;
            display: block;
            width: 21px;
            height: 22px;
            background-repeat: no-repeat;
            font-size: 0;
            line-height: 0;
            text-indent: -1000px;
            overflow: hidden;
        }
        .tx-richtextbox-menu {
            background: #f9f9f9;
            padding: 0;
            border: 1px solid #bababa;
            width: 181px;
            position: absolute;
            z-index: 15000;
        }
        .tx-richtextbox-menu a {
            cursor: pointer;
            display: block;
            text-decoration: none;
        }
        .tx-richtextbox-menu div.tx-menu-header {
            margin: 6px 8px 0 8px;
        }
        .tx-richtextbox-menu div.tx-menu-preview-area {
            background: #fff;
            border: 1px solid #e9e9e9;
            padding: 4px 4px;
        }
        .tx-richtextbox-menu div.tx-menu-preview-area div.tx-menu-preview {
            height: 20px;
            border: 1px solid #ddd;
        }
        .tx-richtextbox-menu div.tx-menu-inner {
            border: 1px solid #ddd;
            border-top: 0;
            background: #fff;
            padding: 5px;
            margin: 0 8px 0 8px;
        }
        .tx-richtextbox-menu .tx-advanced-list div.tx-menu-inner {
            border: 0;
            margin: 0;
            background: #f9f9f9;
            padding: 8px 0 8px 8px;
        }
        .tx-richtextbox-menu div.tx-menu-list table {
            background-image: url(/editor/images/icon/editor/textbox/textbox.gif?v=2);
            background-repeat: no-repeat;
            border-collapse: collapse;
            width: 150px;
            background-position: -2px -2px;
        }
        * + html .tx-richtextbox-menu div.tx-menu-list table {
            background-position: -1px -1px;
        }
        * html .tx-richtextbox-menu div.tx-menu-list table {
            background-position: -1px -1px;
        }
        .tx-richtextbox-menu div.tx-menu-list td,
        .tx-richtextbox-menu div.tx-menu-list td a {
            width: 22px;
            border: 1px solid #fff;
            padding: 0;
        }
        .tx-richtextbox-menu div.tx-menu-list td a:hover {
            border: 1px solid #768fbd;
        }
        .tx-richtextbox-menu div.tx-menu-list td a span {
            color: #333;
            cursor: pointer;
            display: block;
            height: 22px;
            overflow: hidden;
            text-align: center;
            text-indent: -100em;
            width: 22px;
        }
        .tx-richtextbox-menu .tx-menu-switch {
            margin-top: 5px;
            border-top: 1px solid #ddd;
            border-left: 1px solid #ddd;
            padding: 0;
            height: 23px;
            border-bottom: 0;
            border-right: 0;
        }
        .tx-richtextbox-menu .tx-menu-switch div {
            float: left;
            width: 50%;
            height: 100%;
            background: #f9f9f9;
            border-bottom: 1px solid #ddd;
        }
        .tx-richtextbox-menu .tx-menu-switch div a {
            display: block;
            height: 100%;
            border-right: 1px solid #ddd;
        }
        .tx-richtextbox-menu .tx-menu-switch div a span {
            position: relative;
            left: 15px;
            top: 5px;
            font-family: dotum;
            font-size: 11px;
            color: #000;
        }
        .tx-richtextbox-menu .tx-menu-switch div.tx-selected {
            border-bottom: 1px solid #fff;
            background: #fff;
        }
        .tx-richtextbox-menu .tx-menu-footer {
            clear: both;
            height: 20px;
            margin: 6px 0 6px 0;
            padding-left: 55px;
        }
        .tx-richtextbox-menu div.tx-menu-footer img.tx-menu-confirm {
            cursor: pointer;
        }
        .tx-richtextbox-menu div.tx-menu-footer img.tx-menu-cancel {
            cursor: pointer;
        }
        .tx-richtextbox-menu div.tx-menu-rowcol {
            border: 1px solid #e9e9e9;
            border-top: none;
            background-color: #fff;
            padding: 5px 4px;
            clear: both;
            height: 18px;
            font-family: dotum;
            font-size: 11px;
        }
        .tx-richtextbox-menu div.tx-menu-rowcol .tx-col-area {
            float: left;
            position: relative;
            color: #333;
            width: 58px;
            background: url(/editor/images/icon/editor/ic_col.gif?v=2) no-repeat 0 3px;
            padding-left: 12px;
        }
        .tx-richtextbox-menu div.tx-menu-rowcol .tx-row-area {
            float: right;
            position: relative;
            color: #333;
            width: 60px;
            background: url(/editor/images/icon/editor/ic_row.gif?v=2) no-repeat 0 3px;
            padding-left: 14px;
        }
        .tx-richtextbox-menu div.tx-menu-rowcol label {
            font-family: dotum;
            font-size: 11px;
            padding-right: 3px;
        }
        .tx-richtextbox-menu div.tx-menu-rowcol input {
            vertical-align: middle;
            width: 30px;
            height: 14px;
            color: #333;
            padding: 1px 0 1px 2px;
            border: 1px solid #b8b8b8;
            border-right: 1px solid #eaeaea;
            border-bottom: 1px solid #eaeaea;
            font-size: 11px;
        }
        .tx-richtextbox-menu div.tx-menu-rowcol .btn_add {
            position: absolute;
            top: 1px;
            right: 3px;
            z-index: 999;
            display: block;
            width: 15px;
            height: 8px;
            text-indent: -100em;
            background: url(/editor/images/icon/editor/btn_plus.gif?v=2) no-repeat;
            overflow: hidden;
            margin: 0;
            padding: 0;
        }
        .tx-richtextbox-menu div.tx-menu-rowcol .btn_sub {
            position: absolute;
            top: 9px;
            right: 3px;
            z-index: 999;
            display: block;
            width: 15px;
            height: 8px;
            text-indent: -100em;
            background: url(/editor/images/icon/editor/btn_minus.gif?v=2) no-repeat;
            overflow: hidden;
            margin: 0;
            padding: 0;
        }
        * html .tx-richtextbox-menu div.tx-menu-rowcol .btn_add {
            top: 2px;
            margin: 0;
            padding: 0;
        }
        * html .tx-richtextbox-menu div.tx-menu-rowcol .btn_sub {
            top: 10px;
            margin: 0;
            padding: 0;
        }
        .tx-richtextbox-menu div.tx-advanced-list {
            margin-top: 5px;
            padding: 6px 0;
        }
        .tx-richtextbox-menu div.tx-advanced-list table {
            border-collapse: collapse;
        }
        .tx-richtextbox-menu div.tx-advanced-list td {
            padding: 0;
        }
        .tx-richtextbox-menu div.tx-advanced-list dl {
            clear: both;
            margin: 4px 0 0 0;
            height: 18px;
            font-family: dotum;
            font-size: 11px;
        }
        .tx-richtextbox-menu div.tx-advanced-list dt {
            float: left;
            color: #333;
            text-align: left;
            width: 55px;
            padding: 4px 0 0 0;
        }
        .tx-richtextbox-menu div.tx-advanced-list dd {
            float: left;
            color: #333;
            text-align: left;
        }
        .tx-richtextbox-menu div.tx-advanced-list dd input {
            vertical-align: middle;
            width: 36px;
            height: 14px;
            font-size: 11px;
            color: #333;
            padding: 1px 0 1px 2px;
            border: 1px solid #b8b8b8;
            border-right: 1px solid #eaeaea;
            border-bottom: 1px solid #eaeaea;
        }
        .tx-richtextbox-menu div.tx-advanced-list dd .btn_add {
            position: absolute;
            top: 1px;
            right: 1px;
            z-index: 999;
            display: block;
            width: 15px;
            height: 8px;
            text-indent: -100em;
            background: url(/editor/images/icon/editor/btn_plus.gif?v=2) no-repeat;
            overflow: hidden;
            margin: 0;
            padding: 0;
        }
        .tx-richtextbox-menu div.tx-advanced-list dd .btn_sub {
            position: absolute;
            top: 9px;
            right: 1px;
            z-index: 999;
            display: block;
            width: 15px;
            height: 8px;
            text-indent: -100em;
            background: url(/editor/images/icon/editor/btn_minus.gif?v=2) no-repeat;
            overflow: hidden;
            margin: 0;
            padding: 0;
        }
        * html .tx-richtextbox-menu div.tx-advanced-list .btn_add {
            top: 3px;
            margin: 0;
            padding: 0;
        }
        * html .tx-richtextbox-menu div.tx-advanced-list .btn_sub {
            top: 11px;
            margin: 0;
            padding: 0;
        }
        .tx-richtextbox-menu div.tx-advanced-list dd {
            position: relative;
        }
        .tx-richtextbox-menu div.tx-advanced-list dd.tx-color-wrap {
            z-index: 10000;
        }
        .tx-richtextbox-menu div.tx-advanced-list dd .tx-color-box {
            float: left;
            border: 1px solid #dfdfdf;
            padding: 2px;
            width: 34px;
        }
        .tx-richtextbox-menu div.tx-advanced-list dd .tx-color-box .tx-color-bg-thumb {
            float: left;
            display: block;
            width: 34px;
            height: 12px;
            overflow: hidden;
            cursor: pointer;
        }
        .tx-richtextbox-menu div.tx-advanced-list dd .tx-color-box .tx-color-border-thumb {
            float: left;
            display: block;
            width: 34px;
            height: 12px;
            overflow: hidden;
            cursor: pointer;
        }
        .tx-richtextbox-menu div.tx-advanced-list dd .tx-colorpallete {
            left: -95px;
            top: 16px;
        }
        .tx-richtextbox-menu div.tx-advanced-list dd a.tx-color-arrow-up {
            float: left;
            display: block;
            width: 13px;
            height: 18px;
            background: url(/editor/images/icon/editor/btn_cb_spread.gif?v=2) no-repeat 100% 0;
            cursor: pointer;
        }
        .tx-richtextbox-menu div.tx-advanced-list dd a.tx-color-arrow-down {
            float: left;
            display: block;
            width: 13px;
            height: 18px;
            background: url(/editor/images/icon/editor/btn_cb_spread.gif?v=2) no-repeat 100% 0;
            cursor: pointer;
        }
        .tx-richtextbox-menu div.tx-menu-enter {
            margin-top: 9px;
            clear: both;
            height: 20px;
            padding-left: 48px;
        }
        .tx-richtextbox-menu div.tx-menu-enter img {
            cursor: pointer;
        }
        .tx-richtextbox-menu dd {
            margin-left: 0;
        }
        .tx-richtextbox-menu .tx-border-area a {
            display: block;
            width: 22px;
            height: 22px;
            border: 1px solid #fff;
        }
        .tx-richtextbox-menu .tx-border-area a:hover {
            border: 1px solid #768fbd;
        }
        .tx-richtextbox-menu .tx-border-area img {
            border: 0;
        }
        .tx-list .tx-image a {
            height: 25px;
            width: 35px;
            background-position: 0 6px;
        }
        .tx-image a:hover {
            background-position: 0 -18px;
        }
        .tx-toolbar-basic .tx-list .tx-image a {
            background-position: 7px 4px;
            width: 42px;
        }
        .tx-list .tx-file a {
            height: 25px;
            width: 33px;
            background-position: -106px 6px;
        }
        .tx-file a:hover {
            background-position: -106px -18px;
        }
        .tx-toolbar-basic .tx-list .tx-file a {
            background-position: -100px 4px;
            width: 46px;
        }
        .tx-list .tx-media a {
            height: 25px;
            width: 49px;
            background-position: -425px 6px;
        }
        .tx-media a:hover {
            background-position: -425px -18px;
        }
        .tx-resize-bar {
            cursor: row-resize;
            text-align: center;
            font-size: 0;
            line-height: 0;
            height: 16px;
        }
        .tx-resize-bar img {
            position: relative;
            top: -6px;
            -moz-user-select: none;
            -khtml-user-select: none;
        }
        .tx-resize-bar img {
            cursor: row-resize;
            margin: 0 auto;
        }
        .tx-resize-bar div.tx-resize-bar-bg {
            background-color: #f9f9f9;
            font-size: 0;
            line-height: 0;
            height: 4px;
            border: 1px solid #cdcdcd;
            border-top: 1px solid #eee;
        }
        * html .tx-resize-bar div.tx-resize-bar-bg {
            height: 6px;
        }
        .tx-blackbox {
            position: absolute;
            display: none;
            z-index: 500;
        }
        .tx-blackbox .tx-blackbox-panel {
            position: absolute;
            top: 0;
            left: 0;
            background-color: #000;
            opacity: 0.3;
            filter: alpha(opacity=30);
        }
        .tx-blackbox .tx-content {
            background-color: #fff;
            margin: 0;
            position: absolute;
        }
        .tx-canvas-notice {
            width: 100%;
            height: 100%;
            z-index: 200000;
            position: absolute;
            color: #000;
            font-size: 15px;
        }
        .tx-canvas-notice span {
            vertical-align: middle;
            margin-top: 150px;
        }
        .tx-canvas-notice a {
            text-decoration: underline;
            margin-top: 150px;
            cursor: pointer;
        }
        .tx-noticebox {
            text-indent: 10px;
            font-size: 0;
            width: 315px;
            height: 130px;
        }
        .tx-noticebox dl {
            background: #f4f2f9;
            font-family: dotum, verdana, sans-serif;
            font-size: 11px;
            border: 1px solid #cfd3e5;
            margin: 0 auto;
            padding: 10px 5px 5px 5px;
        }
        .tx-noticebox dt {
            margin: 0;
            padding: 0;
            background: #f4f2f9;
            height: 20px;
            font: bold 12px dotum;
            color: #7b81dc;
        }
        .tx-noticebox dt span {
            float: left;
        }
        .tx-noticebox dt a {
            width: 14px;
            height: 13px;
            float: right;
            text-indent: -100em;
            background: url(/editor/images/icon/editor/btn_a_close.gif?v=2) no-repeat left top;
        }
        .tx-noticebox dd {
            margin: 0;
            padding: 10px 10px 0 10px;
            background: #fff;
            height: 110px;
            font-size: 11px;
            color: #4d4d4d;
        }
        .tx-noticebox dd p {
            text-indent: 0;
            margin: 0 10px;
            padding: 10px 0;
        }
        .tx-noticebox dd div {
            border-top: 1px solid #f1f1f1;
            margin: 0;
            text-align: center;
            padding: 10px 0 0 0;
        }
        .tx-noticebox dd div a {
            text-indent: 0;
        }
        .tx-noticebox .box-back {
            width: 100%;
            height: 100%;
        }
        .tx-attach-active {
            display: none;
            position: absolute;
            z-index: 100000;
            background-color: #7e94bf;
            filter: alpha(opacity=30);
            opacity: 0.3;
        }
        .tx-attach-div {
            margin: 10px 0 0 0;
            display: none;
        }
        .tx-attach-div div.tx-attach-txt {
            float: left;
            font-weight: bold;
            font-family: gulim, tahoma, sans-serif;
            font-size: 12px;
            line-height: 1.4;
        }
        .tx-attach-box {
            border: 1px #d5d5d5 solid;
            background: #fafafa;
            margin: 10px 0 15px 70px;
            padding: 0 0 5px 0;
        }
        .tx-attach-box .tx-attach-box-inner {
            border: 1px #fff solid;
            padding: 5px 0 0 5px;
        }
        .tx-attach-box .tx-attach-preview {
            float: left;
            width: 147px;
            height: 108px;
            margin: 0;
            background: #fff;
            position: relative;
            padding: 5px;
            border: 1px #eaeaea solid;
        }
        .tx-attach-box .tx-attach-preview p {
            display: none;
        }
        .tx-attach-box .tx-attach-preview img {
            display: block;
            margin: 0 auto;
            -moz-user-select: none;
            -khtml-user-select: none;
        }
        .tx-attach-box p.tx-thumb-pie {
            position: absolute;
            display: block;
            z-index: 10;
            top: 82px;
            left: 8px;
            width: 13px;
            height: 13px;
            background: url(/editor/images/icon/editor/ic_pie.gif?v=2) no-repeat;
        }
        .tx-attach-box p.tx-thumb-movie {
            position: absolute;
            display: block;
            z-index: 10;
            top: 73px;
            left: 22px;
            width: 13px;
            height: 13px;
            background: url(/editor/images/icon/editor/ic_play01.gif?v=2) no-repeat;
        }
        .tx-attach-box .tx-attach-main {
            height: 118px;
            position: relative;
        }
        .tx-attach-box .tx-upload-progress {
            position: absolute;
            z-index: 20;
            top: 45px;
            left: 320px;
            width: 300px;
            height: 40px;
            padding: 10px;
            border: 1px #aaa solid;
            background: #fff;
            display: none;
        }
        * + html .tx-attach-box .tx-upload-progress {
            left: 150px;
        }
        * html .tx-attach-box .tx-upload-progress {
            left: 150px;
        }
        .tx-attach-box .tx-upload-progress div {
            border: 1px #ddd solid;
            background: #fb6235 url(/editor/images/icon/editor/progress_01.gif?v=2);
            width: 10px;
            height: 15px;
            font-size: 11px;
            font-family: dotum, verdana;
            color: #fff;
            text-align: center;
            padding: 3px 0 2px;
        }
        .tx-attach-box .tx-upload-progress p {
            font-size: 11px;
            font-family: dotum, verdana;
            color: #666;
            text-align: center;
        }
        .tx-attach-box .tx-attach-top {
            height: 21px;
            margin: 1px 0 4px 0;
        }
        .tx-attach-box .tx-attach-top li {
            list-style: none;
            float: left;
            font-size: 11px;
            font-family: dotum, verdana;
            color: #666;
        }
        .tx-attach-box .tx-attach-delete a {
            display: block;
            margin: 0 4px;
            width: 57px;
            height: 21px;
            text-indent: -100em;
            overflow: hidden;
            background: url(/editor/images/icon/editor/btn_deletefile.gif?v=2) no-repeat;
            cursor: pointer;
        }
        .tx-attach-box li.tx-attach-size {
            float: right;
            padding: 5px 5px 0 0;
        }
        .tx-attach-box .tx-attach-size-up {
            font-weight: bold;
            color: #fb6235;
        }
        .tx-attach-box .tx-attach-size-used {
            font-weight: bold;
        }
        .tx-attach-box .tx-attach-list {
            margin: 0 5px 0 4px;
            height: 84px;
            padding: 3px;
            border: 1px #d5d5d5 solid;
            background: #fff;
            overflow: -moz-scrollbars-vertical;
            scrollbar-3dlight-color: #fff;
            scrollbar-arrow-color: #9f9f9f;
            scrollbar-darkshadow-color: #fff;
            scrollbar-face-color: #e6e6e6;
            scrollbar-highlight-color: #c3c3c3;
            scrollbar-shadow-color: #c3c3c3;
            scrollbar-track-color: #f3f3f3;
            overflow: hidden;
            overflow-y: scroll;
            -moz-user-select: none;
            -khtml-user-select: none;
        }
        .tx-attach-box .tx-attach-list li {
            height: 16px;
            padding: 3px 3px 2px 3px;
            clear: both;
        }
        .tx-attach-box .tx-attach-list li.tx-hovered {
            background: #f2f2f2;
        }
        .tx-attach-box .tx-attach-list li.tx-clicked {
            background: #c8d9f7;
        }
        .tx-attach-box .tx-attach-list li dl {
            width: 100%;
            margin: 0;
            padding: 0;
        }
        .tx-attach-box .tx-attach-list li .tx-name {
            float: left;
            font-size: 11px;
            font-family: dotum, verdana;
            color: #666;
            padding: 1px 0 0 0;
            cursor: pointer;
        }
        .tx-attach-box .tx-attach-list li.tx-existed .tx-name {
            color: #999;
        }
        .tx-attach-box .tx-attach-list .tx-name strong {
            font-family: dotum;
            font-size: 11px;
            color: #ed1c24;
            font-weight: normal;
            letter-spacing: -1px;
        }
        .tx-attach-box .tx-attach-list li.tx-existed .tx-insert {
            display: none;
        }
        .tx-attach-box .tx-attach-list li.tx-boxonly .tx-insert {
            display: none;
        }
        .tx-attach-box .tx-attach-list dd.tx-button {
            float: right;
        }
        .tx-attach-box .tx-attach-list li a.tx-insert {
            float: left;
            display: block;
            width: 15px;
            height: 15px;
            margin: 0 0 0 3px;
            text-indent: -100em;
            overflow: hidden;
            background: url(/editor/images/icon/editor/btn_a_upload.gif?v=2) no-repeat;
            cursor: pointer;
        }
        .tx-attach-box .tx-attach-list li a.tx-delete {
            float: left;
            display: none;
            width: 15px;
            height: 15px;
            text-indent: -100em;
            overflow: hidden;
            background: url(/editor/images/icon/editor/btn_a_delete.gif?v=2) no-repeat;
            cursor: pointer;
        }
        .tx-attach-box .tx-attach-list li.tx-hovered a.tx-delete {
            display: block;
        }
        .tx-attach-box .tx-attach-list li.tx-clicked a.tx-delete {
            display: block;
        }
        .tx-attach-box a.tx-attach-two-images {
            float: left;
            margin-right: 4px;
            width: 21px;
            height: 20px;
            text-indent: -100em;
            overflow: hidden;
            background: url(/editor/images/icon/editor/btn_images_two.gif?v=2) no-repeat;
            cursor: pointer;
        }
        .tx-attach-box a.tx-attach-three-images {
            float: left;
            margin: 0;
            width: 24px;
            height: 20px;
            text-indent: -100em;
            overflow: hidden;
            background: url(/editor/images/icon/editor/btn_images_three.gif?v=2) no-repeat;
            cursor: pointer;
        }
        /* popup */
        body {
            margin: 0;
            padding: 0;
        }
        img {
            border: 0;
        }
        h1,
        h2,
        h3,
        h4,
        h5,
        h6,
        dl,
        dt,
        dd,
        ul,
        li,
        ol,
        th,
        td,
        p,
        blockquote,
        form,
        fieldset,
        legend {
            margin: 0;
            padding: 0;
        }
        body {
            background: #fff;
        }
        body,
        td,
        th {
            font-size: 12px;
            font-family: gulim, sans-serif;
        }
        input,
        textarea {
            vertical-align: middle;
        }
        em {
            font-style: normal;
            font-weight: normal;
        }
        a {
            text-decoration: none;
            color: #333;
        }
        a:hover {
            text-decoration: underline;
        }
        dl,
        dt,
        dd,
        ul,
        ol,
        li,
        p {
            margin: 0;
            padding: 0;
            list-style: none;
        }
        .wrapper {
            margin: 0 auto;
        }
        .header {
            height: 34px;
            padding: 0 9px 0 20px;
            background-image: url(/editor/images/icon/editor/pop_header_bg.gif?v=2);
        }
        .header h1 {
            float: left;
            display: inline;
            font-size: 100%;
            color: #fff;
            font-weight: bold;
            margin-top: 11px;
        }
        .header p {
            float: right;
            width: 200px;
            color: #999;
            font-family: dotum, AppleGothic, sans-serif;
            font-size: 11px;
            letter-spacing: -1px;
            padding-top: 7px;
        }
        .header p em {
            float: right;
            margin-top: 4px;
        }
        .body {
            background-color: #fff;
            padding: 0;
            position: relative;
        }
        .alert {
            padding: 0;
            background: url(/editor/images/icon/editor/file/ico_stop.gif?v=2) 0 0 no-repeat;
            margin: 14px 36px 21px;
            color: #999;
        }
        .alert dt {
            margin: 0;
            font-size: 12px;
            font-weight: bold;
            color: #6486e4;
            padding: 8px 0 9px 37px;
        }
        .alert dd {
            line-height: 17px;
            margin: 0 0 0 36px;
            padding: 0;
        }
        .alert strong {
            color: #a7b9ec;
            font-weight: normal;
        }
        .alert a {
            color: #666;
            text-decoration: none;
            background: url(/editor/images/icon/editor/b_link.gif?v=2) 100% 50% no-repeat;
            padding: 0 7px 0 0;
        }
        .alert a:hover {
            text-decoration: underline;
        }
        .footer {
            padding: 10px 0;
            height: 25px;
            background-color: #e9e9e9;
            clear: both;
            text-align: center;
        }
        .footer ul {
            margin: 0 auto;
            width: 105px;
        }
        .footer li {
            float: left;
        }
        .footer li a {
            display: block;
            text-indent: -5000px;
            background: url(/editor/images/icon/editor/pop_footer_btn.gif?v=2) no-repeat;
            width: 49px;
            height: 25px;
        }
        .footer .submit a {
            background-position: 0 0;
        }
        .footer .cancel a {
            background-position: 100% 0;
            margin-left: 7px;
        }
        .footer p {
            float: right;
            margin: 3px 12px 0 0;
        }
        .footer p a.close {
            display: block;
            text-indent: -5000px;
            background: url(/editor/images/icon/editor/bt_close.gif?v=2) no-repeat;
            width: 38px;
            height: 13px;
        }
        .tx-blackbox {
            position: absolute;
            display: none;
            z-index: 500;
        }
        .tx-blackbox .tx-blackbox-panel {
            position: absolute;
            top: 0;
            left: 0;
            background-color: #000;
            opacity: 0.3;
            filter: alpha(opacity=30);
        }
        .tx-blackbox .tx-content {
            background-color: #fff;
            margin: 0;
            position: absolute;
        }
        .tx-noticebox {
            text-indent: 10px;
            font-size: 0;
            width: 315px;
            height: 130px;
        }
        .tx-noticebox dl {
            background: #f4f2f9;
            font-family: dotum, verdana;
            font-size: 11px;
            border: 1px solid #cfd3e5;
            margin: 0 auto;
            padding: 10px 5px 5px 5px;
        }
        .tx-noticebox dt {
            margin: 0;
            padding: 0;
            background: #f4f2f9;
            height: 20px;
            font: bold 12px dotum;
            color: #7b81dc;
        }
        .tx-noticebox dt span {
            float: left;
        }
        .tx-noticebox dt a {
            width: 14px;
            height: 13px;
            float: right;
            text-indent: -1000em;
            overflow: hidden;
            background: url(/editor/images/icon/editor/btn_a_close.gif?v=2) no-repeat left top;
        }
        .tx-noticebox dd {
            margin: 0;
            padding: 10px 10px 0 10px;
            background: #fff;
            height: 87px;
            font-size: 11px;
            color: #4d4d4d;
        }
        .tx-noticebox dd p {
            text-indent: 0;
            margin: 0 10px;
            padding: 10px 0;
        }
        .tx-noticebox dd div {
            border-top: 1px solid #f1f1f1;
            margin: 0;
            text-align: center;
            padding: 10px 0 0 0;
        }
        .tx-noticebox dd div a {
            text-indent: 0;
        }
        .tx-noticebox .box-back {
            width: 100%;
            height: 100%;
        }
    }
`;

const DetailPage = () => {
    const targetName = useLocation().pathname.split("/");
    const [targetResult, setTargetResult] = useState("");
    const [data, setData] = useState<DetailProps>();

    const { id } = useParams();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const search = searchParams.get("search");

    useEffect(() => {
        if (targetName[2] === "certified-company") {
            setTargetResult("company");
        } else if (targetName[2] === "youtube") {
            setTargetResult("youtube");
        } else if (targetName[2] === "notice") {
            setTargetResult("announcement");
        } else if (targetName[2] === "information") {
            setTargetResult("share");
        }
    }, [targetName]);

    useEffect(() => {
        const fetchData = async () => {
            if (targetResult) {
                try {
                    const response = await axios.get(`${process.env.REACT_APP_API_URL}/${targetResult}/${id}`);
                    setData(response.data.data);
                } catch (error) {
                    console.log(error);
                }
            }
        };

        fetchData();
    }, [id, search, targetResult]);

    return (
        <Container className="detail_common sub_page container xl:mt-160 mt-130">
            <Helmet>
                <meta
                    name="keywords"
                    content="우수조달제품인증, 성능인증, 다수공급자계약, 신제품인증(NEP), 신기술인증(NET), 혁신제품, 벤처기업인증, 조달,경영인증 ,인증컨설팅"
                />
            </Helmet>
            {data && data.video_id && (
                <div className="iframe_video_wrap">
                    <iframe
                        src={`https://www.youtube.com/embed/${data.video_id}`}
                        width="100%"
                        height="auto"
                        title="YouTube video player"
                        allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerPolicy="strict-origin-when-cross-origin"
                        allowFullScreen
                    />
                </div>
            )}
            <div>
                <div className="info_wrap type_01 wrap xl:mb-40 mb-32">
                    {data && data.filter && (
                        <p className="category text-center leading-1em xl:text-16 text-12 font-bold pt-8 pb-8 pr-16 pl-16 mb-16 text-pointColor01">
                            {data.filter}
                        </p>
                    )}
                    <h3 className="tit text-center xl:text-24 text-18 font-bold xl:mb-24 mb-16">
                        {data && data.title}
                    </h3>
                    <div className="sub_info_wrap xl:mt-24 mt-16">
                        <div className="date_wrap">
                            <p className="tit xl:text-16 text-13 font-semibold">Date</p>
                            <p className="txtt xl:text-16 text-13">{data && data.created_at_formatted}</p>
                        </div>
                        <div className="views_wrap">
                            <p className="tit xl:text-16 text-13 font-semibold">Views</p>
                            <p className="txt xl:text-16 text-13">{data && data.views}</p>
                        </div>
                    </div>
                </div>
                <div className="contents_wrap type_01 ql-editor wrap">
                    {data && data.image && <img src={data.image} alt="대표 이미지" />}
                    {data && data.contact ? (
                        <table className="main_table">
                            <tbody>
                                <tr>
                                    <td className="xl:text-16 text-14">회사명</td>
                                    <td className="xl:text-16 text-14">{data.title}</td>
                                </tr>
                                <tr>
                                    <td className="xl:text-16 text-14">전화번호</td>
                                    <td className="xl:text-16 text-14">{data.contact}</td>
                                </tr>
                                <tr>
                                    <td className="xl:text-16 text-14">주소</td>
                                    <td className="xl:text-16 text-14">{data.address}</td>
                                </tr>
                                <tr>
                                    <td className="xl:text-16 text-14">품명 및 규격</td>
                                    <td className="xl:text-16 text-14">{data.standard}</td>
                                </tr>
                                <tr>
                                    <td className="xl:text-16 text-14">계약일 및 기간</td>
                                    <td className="xl:text-16 text-14">
                                        {data.contract_at} ~ {data.period}
                                    </td>
                                </tr>
                                <tr>
                                    <td className="xl:text-16 text-14">계약단가금액</td>
                                    <td className="xl:text-16 text-14">
                                        {new Intl.NumberFormat().format(Number(data.price))}원
                                    </td>
                                </tr>
                                <tr>
                                    <td className="xl:text-16 text-14">관할지역</td>
                                    <td className="xl:text-16 text-14">{data.region}</td>
                                </tr>
                                <tr>
                                    <td className="xl:text-16 text-14">예약품명종류수</td>
                                    <td className="xl:text-16 text-14">{data.reservation}건</td>
                                </tr>
                                <tr>
                                    <td className="xl:text-16 text-14">계약품목총개수</td>
                                    <td className="xl:text-16 text-14">{data.contract}개</td>
                                </tr>
                            </tbody>
                        </table>
                    ) : (
                        data && (
                            <div className="tx-content-container">
                                <div
                                    className="item editor-item"
                                    dangerouslySetInnerHTML={{
                                        __html: DOMPurify.sanitize(data.content),
                                    }}
                                />
                            </div>
                        )
                    )}
                    {data ? (
                        data.files &&
                        data.files.map((files, index) => (
                            <a
                                href={`${process.env.REACT_APP_API_URL}/download?id=${data.id}&file_id=${files.file_id}&model=${targetResult}`}
                                className="btn_download"
                                key={index}
                            >
                                <i className="icon xi-folder-open fs_type_11"></i>
                                <p className="txt fs_type_11 fw_type_03 file_name">{files.original_file_name}</p>
                                <i className="icon icon_download xi-download fs_type_11"></i>
                            </a>
                        ))
                    ) : (
                        <div className="icon_loading_wrap">
                            <i className="xi-spinner-2 xi-spin icon_loading"></i>
                        </div>
                    )}
                </div>
                {data && <NoticeDetailNav data={data} />}
            </div>
        </Container>
    );
};

export default DetailPage;
